import _, { isObject } from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { myTaskActionsListName } from "src/api/config/myTasksActions.config";
import {
  myTasksDepartmentsListName,
  myTasksDependListName,
  myTasksLocationsListName,
  myTasksRegionsListName,
} from "src/api/config/myTasksLists.config";
import Form from "src/components/Form";
import Loading from "src/components/Loading";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { getItemsRequest } from "src/modules/spItems/api";
import { selectItems } from "src/modules/spItems/selectors";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import {
  myTasksIncidentsRecipientsListListName,
  myTasksIncidentstListName,
  myTasksTypeIncidentsListName,
} from "src/api/config/myTasksInc.config";
import LoadingOpBg from "src/components/LoadingOpBg";
import {
  myTasks5WayListName,
  myTasksSDCA5WayListName,
} from "src/api/config/myTasks5Way.config";
import { Breadcrumbs } from "src/components/Breadcrumb";
import { ReportIcon } from "src/components/ui-icons/sidebar";
import { WarningSmallIcon } from "src/components/ui-icons/myTasks/WarningIcon";
import TGButton from "src/components/ui/TGButton";
import { ChartOptions } from "chart.js";
import BarChart from "./BarChart";
import PaginationLeftSmallIcon from "./icon/PaginationLeftSmallIcon";
import PaginationRightSmallIcon from "./icon/PaginationRightSmallIcon";
import ChartLicense from "src/pages/DashboardPage/gos/components/chart-license/chart-license";
import { Modal } from "src/components/DialogComponent";
import { emailsSender, siteUrl } from "src/api/config";
import {
  downloadOutlookEmailWithAttachments,
  getRandomColor,
  urlDefault,
} from "src/constants";
import { emailAPI } from "src/utils/api.utils";
import html2canvas from "html2canvas";
import {
  actionsStatus,
  incStatus,
  incTypes,
  isStrapi,
} from "src/api/config/systemSwitch";
import { selectCurrentUser } from "src/modules/users/selector";
const { sendEmail } = emailAPI();

function IncidentsFilters({ setFilters, setGegIncidents, setPeriod }: any) {
  const [defaultValues, setDefaultValues] = useState(null);
  const [fields, setFields] = useState<any>([
    {
      type: "dateRange",
      require: false,
      key: "DateIncidents",
      title: "Дата регистрации",
      placeholder: "дд.мм.гггг",
      isFilter: true,
      condition: null,
      width: "w-full",
    },
    {
      type: "dateRange",
      require: false,
      key: "DateIncidents2",
      title: "Дата инцидента",
      placeholder: "дд.мм.гггг",
      isFilter: true,
      condition: null,
      width: "w-full",
    },
    {
      type: "radio",
      require: false,
      isFilter: true,
      title: "Тип инцидента",
      key: "TypeIncident",
      condition: null,
      width: "w-full",
    },
    {
      type: "peoplePicker",
      require: false,
      single: true,
      key: "ResponsibleEmail",
      title: "ФИО инициатора",
      isFilter: true,
      condition: null,
      placeholder: "Введите имя или фамилию",
      width: "w-full",
    },

    {
      type: "checkbox",
      require: false,
      key: "Location",
      isFilter: true,
      title: "Локация, где произошел инцидент",
      condition: null,
      width: "w-full",
    },
    {
      type: "checkbox",
      require: false,
      key: "Department",
      isFilter: true,
      title: "Отдел, где произошел инцидент",
      condition: null,
      width: "w-full",
    },
    {
      type: "checkbox",
      require: false,
      key: "Region",
      isFilter: true,
      title: "Участок, где произошел инцидент",
      condition: null,
      width: "w-full",
    },
  ]);
  const [incidentsFilter, setIncidentsFilter] = useState<any>(null);

  const collections: any = useAppSelector((state) =>
    selectItems(state, myTasksLocationsListName)
  );
  const departments: any = useAppSelector((state) =>
    selectItems(state, myTasksDepartmentsListName)
  );
  const sectors: any = useAppSelector((state) =>
    selectItems(state, myTasksRegionsListName)
  );
  const typesIncList: any = useAppSelector((state) =>
    selectItems(state, myTasksTypeIncidentsListName)
  );

  const [currentTypeInc, setCurrentTypeInc] = useState<any>("Безопасность");

  const [dependenceFields, setDependenceFields] = useState<any>({
    Location: null,
    Department: null,
    Region: null,
  });

  const [customLoading, setCustomLoading] = useState(true);

  const [resetFilters, setResetFiters] = useState(false);

  const [typesInc, setTypesInc] = useState<any>([]);

  useEffect(() => {
    const tempFieldsForm = [...fields];
    for (let i = 0; i < tempFieldsForm.length; i++) {
      if (tempFieldsForm[i]["key"] === "Location") {
        tempFieldsForm[i]["optionsInputs"] = collections.map(
          (collection: any) => {
            return {
              id: collection.ID,
              name: collection.Title,
              disabled: false,
            };
          }
        );
      }
      if (tempFieldsForm[i]["key"] === "Department") {
        tempFieldsForm[i]["optionsInputs"] = departments.map(
          (department: any) => {
            return {
              id: department.ID,
              name: department.Title,
              disabled: false,
            };
          }
        );
      }
      if (tempFieldsForm[i]["key"] === "Region") {
        tempFieldsForm[i]["optionsInputs"] = sectors.map((sector: any) => {
          return {
            id: sector.ID,
            name: sector.Title,
            disabled: false,
          };
        });
      }
      if (tempFieldsForm[i]["key"] === "TypeIncident") {
        tempFieldsForm[i]["optionsInputs"] =
          typesInc.map((type: any) => type.Title.trim()) || [];
      }
    }
    setFields([...tempFieldsForm]);
  }, [collections, departments, sectors, typesInc]);

  useEffect(() => {
    let filtersDependDocuments: any = {};
    const tempFieldsForm = [...fields];
    Object.keys(dependenceFields).map((key) => {
      for (let i = 0; i < tempFieldsForm.length; i++) {
        if (tempFieldsForm[i]["key"] === key) {
          tempFieldsForm[i]["optionsInputs"] = tempFieldsForm[i][
            "optionsInputs"
          ].map((option: any) => {
            return {
              id: option.id,
              name: option.name,
              disabled: false,
            };
          });
        }
      }
    });
    Object.keys(dependenceFields).map((key) => {
      if (dependenceFields[key] && dependenceFields[key].length > 0) {
        filtersDependDocuments[key] = dependenceFields[key].map(
          (item: any) => item.id
        );
      }
    });
    if (Object.keys(filtersDependDocuments).length === 0) {
      setFields([...tempFieldsForm]);
      setCustomLoading(false);
    } else {
      if (Object.keys(filtersDependDocuments).length > 0) {
        //Устанавливаем зависимости в фильтрах
        getItemsRequest({
          listName: myTasksDependListName,
          filters: filtersDependDocuments,
          filtersType: "or",
        }).then((results) => {
          const dependDocuments = [...results.items];
          const collectionIds = _.uniqWith(
            dependDocuments.map((item: any) => item.Location.get_lookupId()),
            _.isEqual
          );
          const departmentIds = _.uniqWith(
            dependDocuments.map((item: any) => item.Departament.get_lookupId()),
            _.isEqual
          );
          const sectorIds = _.uniqWith(
            dependDocuments.map((item: any) => item.Region.get_lookupId()),
            _.isEqual
          );
          for (let i = 0; i < tempFieldsForm.length; i++) {
            if (tempFieldsForm[i]["key"] === "Location") {
              if (
                !filtersDependDocuments["Location"] ||
                Object.keys(filtersDependDocuments).length > 1
              ) {
                tempFieldsForm[i]["optionsInputs"] = collections.map(
                  (collection: any) => {
                    return {
                      id: collection.ID,
                      name: collection.Title,
                      disabled: false, // collectionIds.indexOf(collection.ID) === -1,
                      hide: collectionIds.indexOf(collection.ID) === -1,
                    };
                  }
                );
              }
            }
            if (tempFieldsForm[i]["key"] === "Department") {
              if (
                !filtersDependDocuments["Department"] ||
                Object.keys(filtersDependDocuments).length > 1
              ) {
                tempFieldsForm[i]["optionsInputs"] = departments.map(
                  (department: any) => {
                    return {
                      id: department.ID,
                      name: department.Title,
                      disabled: false, // departmentIds.indexOf(department.ID) === -1,
                      hide: departmentIds.indexOf(department.ID) === -1,
                    };
                  }
                );
              }
            }
            if (tempFieldsForm[i]["key"] === "Region") {
              if (
                !filtersDependDocuments["Region"] ||
                Object.keys(filtersDependDocuments).length > 1
              ) {
                tempFieldsForm[i]["optionsInputs"] = sectors.map(
                  (sector: any) => {
                    return {
                      id: sector.ID,
                      name: sector.Title,
                      disabled: false, // sectorIds.indexOf(sector.ID) === -1,
                      hide: sectorIds.indexOf(sector.ID) === -1,
                    };
                  }
                );
              }
            }
          }
          setFields([...tempFieldsForm]);
          setCustomLoading(false);
        });
      }
    }
  }, [dependenceFields]);

  useEffect(() => {
    if (typesIncList.length > 0) {
      setTypesInc(
        typesIncList.filter((type: any) => type.ID !== incTypes.security)
      );
    }
  }, [typesIncList]);

  useEffect(() => {
    setDependenceFields({
      Location: null,
      Department: null,
      Region: null,
    });
    let defaultObj: any = {};
    fields.map((field: any) => {
      if (field.key === "DateIncidents" || field.key === "DateIncidents2") {
        defaultObj[field.key] =
          (incidentsFilter && incidentsFilter[field.key]) ||
          (field.key === "DateIncidents" && {
            startDate: moment().startOf("month").format("YYYY-MM-DD"),
            endDate: moment().endOf("month").format("YYYY-MM-DD"),
          }) ||
          null;
      } else if (field.key === "TypeIncident") {
        defaultObj[field.key] = "Безопасность";
      } else {
        defaultObj[field.key] = null;
      }
    });
    setDefaultValues(defaultObj);
  }, [resetFilters]);

  useEffect(() => {
    if (
      incidentsFilter &&
      Object.keys(incidentsFilter).length > 0 &&
      typesInc.length > 0
    ) {
      const existsFiltersIncidents: any = {};
      Object.keys(incidentsFilter).map((key) => {
        if (incidentsFilter[key]) {
          if (Array.isArray(incidentsFilter[key])) {
            if (incidentsFilter[key].length > 0) {
              existsFiltersIncidents[key] = incidentsFilter[key];
            }
          } else if (isObject(incidentsFilter[key])) {
            if (Object.keys(incidentsFilter[key]).length > 0) {
              existsFiltersIncidents[key] = incidentsFilter[key];
            }
          } else {
            existsFiltersIncidents[key] = incidentsFilter[key];
          }
        }
      });
      const tempFilters: any = {};
      console.log("existsFiltersIncidents: ", existsFiltersIncidents);
      Object.keys(existsFiltersIncidents).map((key) => {
        if (key === "DateIncidents") {
          setPeriod({
            start: moment(existsFiltersIncidents[key].startDate).unix(),
            end: moment(existsFiltersIncidents[key].endDate).unix(),
          });
        } else if (key === "DateIncidents2") {
          tempFilters[key] = {
            start: moment(existsFiltersIncidents[key].startDate).format(
              "YYYY-MM-DD"
            ),
            end: moment(existsFiltersIncidents[key].endDate).format(
              "YYYY-MM-DD"
            ),
          };
        } else if (key === "ResponsibleEmail") {
          tempFilters[key] = `${existsFiltersIncidents[key][0]["value"]}*`;
        } else if (key === "TypeIncident") {
          const idCurrentTypeInc = typesInc.filter(
            (type: any) => type.Title === currentTypeInc
          )[0]["ID"];
          tempFilters[key] = idCurrentTypeInc;
        } else if (
          key === "Location" ||
          key === "Department" ||
          key === "Region"
        ) {
          tempFilters[key] = existsFiltersIncidents[key].map(
            (item: any) => item.id
          );
        }
      });
      setGegIncidents(false);
      setFilters({
        ...tempFilters,
        Questions: [`"IncidentOption":"Инцидент"`],
      });
    }
  }, [incidentsFilter, typesInc]);

  return (
    <FlexCol className="relative">
      {incidentsFilter && Object.keys(incidentsFilter).length > 0 && (
        <div
          onClick={() => {
            setFilters({});
            setResetFiters(!resetFilters);
            setGegIncidents(false);
            setIncidentsFilter(null);
          }}
          className="p-5 flex flex-row group items-center text-[14px] text-[#637381] cursor-pointer gap-x-2 flex-nowrap border-b"
        >
          <div className="flex flex-col">Сбросить фильтры</div>
          <div className="flex flex-col pt-1">
            <svg
              width="16"
              height="16"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_33_4954)">
                <path
                  d="M5.9998 5.39995L1.4248 0.824951C1.25605 0.656201 0.993555 0.656201 0.824805 0.824951C0.656055 0.993701 0.656055 1.2562 0.824805 1.42495L5.3998 5.99995L0.824805 10.575C0.656055 10.7437 0.656055 11.0062 0.824805 11.175C0.993555 11.3437 1.25605 11.3437 1.4248 11.175L5.9998 6.59995L10.5748 11.175C10.7436 11.3437 11.0061 11.3437 11.1748 11.175C11.2498 11.1 11.3061 10.9875 11.3061 10.875C11.3061 10.7625 11.2686 10.65 11.1748 10.575L6.5998 5.99995L11.1748 1.42495C11.2498 1.34995 11.3061 1.23745 11.3061 1.12495C11.3061 1.01245 11.2686 0.899951 11.1748 0.824951C11.0061 0.656201 10.7436 0.656201 10.5748 0.824951L5.9998 5.39995Z"
                  fill="#637381"
                ></path>
              </g>
              <defs>
                <clipPath id="clip0_33_4954">
                  <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(0 12) rotate(-90)"
                  ></rect>
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      )}
      {customLoading && <LoadingOpBg />}
      <Form
        type="filter_report_my_tasks_inc"
        setFormData={setIncidentsFilter}
        fieldsForm={[...fields]}
        setCurrentTypeInc={setCurrentTypeInc}
        defaultValues={defaultValues}
        setDependenceFields={setDependenceFields}
      />
      {incidentsFilter && Object.keys(incidentsFilter).length > 0 && (
        <div
          onClick={() => {
            setFilters({});
            setGegIncidents(false);
            setIncidentsFilter(null);
            setResetFiters(!resetFilters);
          }}
          className="p-5 flex flex-row group items-center text-[12px] text-[#637381] cursor-pointer gap-x-2 flex-nowrap"
        >
          <div className="flex flex-col group-hover:underline">
            Сбросить фильтры
          </div>
          <div className="flex flex-col pt-1">
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_33_4954)">
                <path
                  d="M5.9998 5.39995L1.4248 0.824951C1.25605 0.656201 0.993555 0.656201 0.824805 0.824951C0.656055 0.993701 0.656055 1.2562 0.824805 1.42495L5.3998 5.99995L0.824805 10.575C0.656055 10.7437 0.656055 11.0062 0.824805 11.175C0.993555 11.3437 1.25605 11.3437 1.4248 11.175L5.9998 6.59995L10.5748 11.175C10.7436 11.3437 11.0061 11.3437 11.1748 11.175C11.2498 11.1 11.3061 10.9875 11.3061 10.875C11.3061 10.7625 11.2686 10.65 11.1748 10.575L6.5998 5.99995L11.1748 1.42495C11.2498 1.34995 11.3061 1.23745 11.3061 1.12495C11.3061 1.01245 11.2686 0.899951 11.1748 0.824951C11.0061 0.656201 10.7436 0.656201 10.5748 0.824951L5.9998 5.39995Z"
                  fill="#637381"
                ></path>
              </g>
              <defs>
                <clipPath id="clip0_33_4954">
                  <rect
                    width="12"
                    height="12"
                    fill="white"
                    transform="translate(0 12) rotate(-90)"
                  ></rect>
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      )}
    </FlexCol>
  );
}

export function IncidentsReport() {
  const typesIncList: any = useAppSelector((state) =>
    selectItems(state, myTasksTypeIncidentsListName)
  );
  const currentUser: any = useAppSelector((state) => selectCurrentUser(state));
  const [typesInc, setTypesInc] = useState<any>([]);
  const [filters, setFilters] = useState<any>({});
  const [nextPage, setNextPage] = useState<any>(null);
  const [tempIncidents, setTempIncidents] = useState<any>([]);
  const [incidents, setIncidents] = useState<any>([]);
  const [customLoading, setCustomLoading] = useState(true);
  const [getIncidents, setGegIncidents] = useState(false);
  const [openSendReportModal, setOpenSendReportModal] = useState(false);
  const [period, setPeriod] = useState<any>(null);
  const [year, setYear] = useState<any>(new Date());
  const months = [
    "Январь",
    "Февраль",
    "Март",
    "Апрель",
    "Май",
    "Июнь",
    "Июль",
    "Август",
    "Сентябрь",
    "Октябрь",
    "Ноябрь",
    "Декабрь",
  ];
  const [monthLabels, setMonthLabels] = useState<any>([]);
  const [factoriesLabels, setFactoriesLabels] = useState<any>([]);
  const [qualityLabels, setQualityLabels] = useState<any>([]);
  const [mLabels, setMLabels] = useState<any>([]);
  const [mLabelsActions, setMLabelsActions] = useState([
    {
      label: "В процессе",
      color: "#F2A900",
      type: "process",
    },
    {
      label: "Просрочено",
      color: "#F23030",
      type: "overdue",
    },
  ]);
  const [maxYMonth, setMaxYMonth] = useState(100);
  const [maxFactory, setMaxFactory] = useState(100);
  const [maxQuality, setMaxQuality] = useState(100);
  const [maxM, setMaxM] = useState(100);
  const [chartYOptions, setChartYOptions] = useState<ChartOptions<"bar">>({
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 8, // Size of the color box (rectangle)
          boxHeight: 8, // Height of the color box
          padding: 20, // Spacing between legend items
        },
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem: any) => {
            return ` ${tooltipItem.dataset.label}: ${tooltipItem.raw}`;
          },
        },
      },
      datalabels: {
        display: true,
        color: "#000", // Label color
        font: {
          size: 14, // Font size
        },
        align: "end", // Position above the bar
        anchor: "end", // Anchor to the end of the bar
        formatter: (value: any) => value, // Display the raw value
      },
    },
    scales: {
      x: {
        grid: {
          display: false, // Убирает сетку, чтобы это не влияло визуально
        },
      },
      y: {
        // stacked: true, // Убедитесь, что это не нарушает поведение оси Y
        beginAtZero: true,
        max: 100, // Устанавливаем максимальное значение оси Y
        ticks: {
          stepSize: 10, // Шаг шкалы кратен 10
          callback: (value: any) => `${value}`, // Отображение значений (например, можно добавить единицы измерения)
        },
      },
    },
  });
  const [chartPeriodOptions, setChartPeriodOptions] = useState<
    ChartOptions<"bar">
  >({
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 8, // Size of the color box (rectangle)
          boxHeight: 8, // Height of the color box
          padding: 20, // Spacing between legend items
        },
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem: any) => {
            return ` ${tooltipItem.dataset.label}: ${tooltipItem.raw}`;
          },
        },
      },
      datalabels: {
        display: true,
        color: "#000", // Label color
        font: {
          size: 14, // Font size
        },
        align: "end", // Position above the bar
        anchor: "end", // Anchor to the end of the bar
        formatter: (value: any) => value, // Display the raw value
      },
    },
    scales: {
      x: {
        grid: {
          display: false, // Убирает сетку, чтобы это не влияло визуально
        },
      },
      y: {
        // stacked: true, // Убедитесь, что это не нарушает поведение оси Y
        beginAtZero: true,
        max: 100, // Устанавливаем максимальное значение оси Y
        ticks: {
          stepSize: 10, // Шаг шкалы кратен 10
          callback: (value: any) => `${value}`, // Отображение значений (например, можно добавить единицы измерения)
        },
      },
    },
  });
  const [chartQualityOptions, setChartQualityOptions] = useState<
    ChartOptions<"bar">
  >({
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 8, // Size of the color box (rectangle)
          boxHeight: 8, // Height of the color box
          padding: 20, // Spacing between legend items
        },
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem: any) => {
            return ` ${tooltipItem.dataset.label}: ${tooltipItem.raw}`;
          },
        },
      },
      datalabels: {
        display: true,
        color: "#000", // Label color
        font: {
          size: 14, // Font size
        },
        align: "end", // Position above the bar
        anchor: "end", // Anchor to the end of the bar
        formatter: (value: any) => value, // Display the raw value
      },
    },
    scales: {
      x: {
        grid: {
          display: false, // Убирает сетку, чтобы это не влияло визуально
        },
      },
      y: {
        // stacked: true, // Убедитесь, что это не нарушает поведение оси Y
        beginAtZero: true,
        max: 100, // Устанавливаем максимальное значение оси Y
        ticks: {
          stepSize: 10, // Шаг шкалы кратен 10
          callback: (value: any) => `${value}`, // Отображение значений (например, можно добавить единицы измерения)
        },
      },
    },
  });
  const [chartMOptions, setChartMOptions] = useState<ChartOptions<"bar">>({
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 8, // Size of the color box (rectangle)
          boxHeight: 8, // Height of the color box
          padding: 20, // Spacing between legend items
        },
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem: any) => {
            return ` ${tooltipItem.dataset.label}: ${tooltipItem.raw}`;
          },
        },
      },
      datalabels: {
        display: true,
        color: "#000", // Label color
        font: {
          size: 14, // Font size
        },
        align: "end", // Position above the bar
        anchor: "end", // Anchor to the end of the bar
        formatter: (value: any) => value, // Display the raw value
      },
    },
    scales: {
      x: {
        grid: {
          display: false, // Убирает сетку, чтобы это не влияло визуально
        },
      },
      y: {
        // stacked: true, // Убедитесь, что это не нарушает поведение оси Y
        beginAtZero: true,
        max: 100, // Устанавливаем максимальное значение оси Y
        ticks: {
          stepSize: 10, // Шаг шкалы кратен 10
          callback: (value: any) => `${value}`, // Отображение значений (например, можно добавить единицы измерения)
        },
      },
    },
  });
  const [chartYearData, setChartYearData] = useState<any>({
    labels: [],
    datasets: [
      {
        label: "В процессе",
        data: [],
        backgroundColor: "#F2A900", // Желтый
        borderRadius: 10,
        barPercentage: 1, // 30px width for each bar
        categoryPercentage: 0.85, // Controls spacing between groups of bars
      },
      {
        label: "Расследование завершено",
        data: [],
        backgroundColor: "#1A8245", // Зеленый
        borderRadius: 10,
        barPercentage: 1, // 30px width for each bar
        categoryPercentage: 0.85, // Controls spacing between groups of bars
      },
      {
        label: "Просрочено",
        data: [],
        backgroundColor: "#F23030", // Красный
        borderRadius: 10,
        barPercentage: 1, // 30px width for each bar
        categoryPercentage: 0.85, // Controls spacing between groups of bars
      },
      {
        label: "Отменено",
        data: [],
        backgroundColor: "#6B7280", // Серый
        borderRadius: 10,
        barPercentage: 1, // 30px width for each bar
        categoryPercentage: 0.85, // Controls spacing between groups of bars
      },
    ],
  });
  const [chartFactoryData, setChartFactoryData] = useState<any>({
    labels: [],
    datasets: [
      {
        label: "В процессе",
        data: [],
        backgroundColor: "#F2A900", // Желтый
        borderRadius: 10,
        barPercentage: 1, // 30px width for each bar
        categoryPercentage: 0.85, // Controls spacing between groups of bars
      },
      {
        label: "Расследование завершено",
        data: [],
        backgroundColor: "#1A8245", // Зеленый
        borderRadius: 10,
        barPercentage: 1, // 30px width for each bar
        categoryPercentage: 0.85, // Controls spacing between groups of bars
      },
      {
        label: "Просрочено",
        data: [],
        backgroundColor: "#F23030", // Красный
        borderRadius: 10,
        barPercentage: 1, // 30px width for each bar
        categoryPercentage: 0.85, // Controls spacing between groups of bars
      },
      {
        label: "Отменено",
        data: [],
        backgroundColor: "#6B7280", // Серый
        borderRadius: 10,
        barPercentage: 1, // 30px width for each bar
        categoryPercentage: 0.85, // Controls spacing between groups of bars
      },
    ],
  });
  const [chartQualityData, setChartQualityData] = useState<any>({
    labels: [],
    datasets: [
      {
        label: "Физико-химия",
        data: [],
        backgroundColor: "#F2A900", // Желтый
        borderRadius: 10,
        barPercentage: 1, // 30px width for each bar
        categoryPercentage: 0.85, // Controls spacing between groups of bars
      },
      {
        label: "Микробиология",
        data: [],
        backgroundColor: "#1A8245", // Зеленый
        borderRadius: 10,
        barPercentage: 1, // 30px width for each bar
        categoryPercentage: 0.85, // Controls spacing between groups of bars
      },
      {
        label: "Блокировка",
        data: [],
        backgroundColor: "#F23030", // Красный
        borderRadius: 10,
        barPercentage: 1, // 30px width for each bar
        categoryPercentage: 0.85, // Controls spacing between groups of bars
      },
      {
        label: "Пищевая Безопасность",
        data: [],
        backgroundColor: "#6B7280", // Серый
        borderRadius: 10,
        barPercentage: 1, // 30px width for each bar
        categoryPercentage: 0.85, // Controls spacing between groups of bars
      },
      {
        label: "Качество Упаковки",
        data: [],
        backgroundColor: "#d629b1",
        borderRadius: 10,
        barPercentage: 1, // 30px width for each bar
        categoryPercentage: 0.85, // Controls spacing between groups of bars
      },
      {
        label: "Сенсорика",
        data: [],
        backgroundColor: "#1597cf",
        borderRadius: 10,
        barPercentage: 1, // 30px width for each bar
        categoryPercentage: 0.85, // Controls spacing between groups of bars
      },
      {
        label: "Другое",
        data: [],
        backgroundColor: "#83cc9b",
        borderRadius: 10,
        barPercentage: 1, // 30px width for each bar
        categoryPercentage: 0.85, // Controls spacing between groups of bars
      },
    ],
  });
  const [chartMData, setChartMData] = useState<any>({
    labels: [],
    datasets: [
      {
        label: "Механика",
        data: [],
        backgroundColor: "#F2A900", // Желтый
        borderRadius: 10,
        barPercentage: 1, // 30px width for each bar
        categoryPercentage: 0.85, // Controls spacing between groups of bars
      },
      {
        label: "Электрика",
        data: [],
        backgroundColor: "#1A8245", // Зеленый
        borderRadius: 10,
        barPercentage: 1, // 30px width for each bar
        categoryPercentage: 0.85, // Controls spacing between groups of bars
      },
      {
        label: "Электроавтоматика",
        data: [],
        backgroundColor: "#F23030", // Красный
        borderRadius: 10,
        barPercentage: 1, // 30px width for each bar
        categoryPercentage: 0.85, // Controls spacing between groups of bars
      },
      {
        label: "Технолог персонал",
        data: [],
        backgroundColor: "#6B7280", // Серый
        borderRadius: 10,
        barPercentage: 1, // 30px width for each bar
        categoryPercentage: 0.85, // Controls spacing between groups of bars
      },
      {
        label: "Здания, коммуникации",
        data: [],
        backgroundColor: "#d629b1",
        borderRadius: 10,
        barPercentage: 1, // 30px width for each bar
        categoryPercentage: 0.85, // Controls spacing between groups of bars
      },
      {
        label: "Другие",
        data: [],
        backgroundColor: "#83cc9b",
        borderRadius: 10,
        barPercentage: 1, // 30px width for each bar
        categoryPercentage: 0.85, // Controls spacing between groups of bars
      },
    ],
  });
  const [chartMActionsData, setChartMActionsData] = useState({});
  const [formDataSendEmails, setFormDataSetEmails] = useState<any>(null);
  const [fieldsSendEmails, setFieldsSetEmails] = useState<any>([
    {
      type: "dateRange",
      require: true,
      key: "DateIncidents",
      title: "Дата регистрации",
      placeholder: "дд.мм.гггг",
      width: "w-full",
    },
    {
      type: "radio",
      require: true,
      title: "Тип инцидента",
      key: "TypeIncident",
      width: "w-full",
    },
    {
      type: "radio",
      require: true,
      title: "Скачать в .eml",
      key: "Msg",
      width: "w-full",
      optionsInputs: ["Да", "Нет"],
    },
  ]);
  const [loadingSendEmail, setLoadingSetEmail] = useState(false);
  const [tempScreenData, setTempScreenData] = useState<any>({});
  const [tempScrenLabels, setTempScrenLabels] = useState<any>([]);

  //Получение инцидентов после изменения фильтров
  useEffect(() => {
    if (!getIncidents && Object.keys(filters).length > 0) {
      console.log("filters: ", filters);
      setCustomLoading(true);
      setTempIncidents([]);
      setIncidents([]);
      setMonthLabels([]);
      setFactoriesLabels([]);
      setQualityLabels([]);
      setMLabels([]);
      setChartYearData({
        labels: [],
        datasets: [
          {
            label: "В процессе",
            data: [],
            backgroundColor: "#F2A900", // Желтый
            borderRadius: 10,
            barPercentage: 1, // 30px width for each bar
            categoryPercentage: 0.85, // Controls spacing between groups of bars
          },
          {
            label: "Расследование завершено",
            data: [],
            backgroundColor: "#1A8245", // Зеленый
            borderRadius: 10,
            barPercentage: 1, // 30px width for each bar
            categoryPercentage: 0.85, // Controls spacing between groups of bars
          },
          {
            label: "Просрочено",
            data: [],
            backgroundColor: "#F23030", // Красный
            borderRadius: 10,
            barPercentage: 1, // 30px width for each bar
            categoryPercentage: 0.85, // Controls spacing between groups of bars
          },
          {
            label: "Отменено",
            data: [],
            backgroundColor: "#6B7280", // Серый
            borderRadius: 10,
            barPercentage: 1, // 30px width for each bar
            categoryPercentage: 0.85, // Controls spacing between groups of bars
          },
        ],
      });
      setChartFactoryData({
        labels: [],
        datasets: [
          {
            label: "В процессе",
            data: [],
            backgroundColor: "#F2A900", // Желтый
            borderRadius: 10,
            barPercentage: 1, // 30px width for each bar
            categoryPercentage: 0.85, // Controls spacing between groups of bars
          },
          {
            label: "Расследование завершено",
            data: [],
            backgroundColor: "#1A8245", // Зеленый
            borderRadius: 10,
            barPercentage: 1, // 30px width for each bar
            categoryPercentage: 0.85, // Controls spacing between groups of bars
          },
          {
            label: "Просрочено",
            data: [],
            backgroundColor: "#F23030", // Красный
            borderRadius: 10,
            barPercentage: 1, // 30px width for each bar
            categoryPercentage: 0.85, // Controls spacing between groups of bars
          },
          {
            label: "Отменено",
            data: [],
            backgroundColor: "#6B7280", // Серый
            borderRadius: 10,
            barPercentage: 1, // 30px width for each bar
            categoryPercentage: 0.85, // Controls spacing between groups of bars
          },
        ],
      });
      setChartQualityData({
        labels: [],
        datasets: [
          {
            label: "Физико-химия",
            data: [],
            backgroundColor: "#F2A900", // Желтый
            borderRadius: 10,
            barPercentage: 1, // 30px width for each bar
            categoryPercentage: 0.85, // Controls spacing between groups of bars
          },
          {
            label: "Микробиология",
            data: [],
            backgroundColor: "#1A8245", // Зеленый
            borderRadius: 10,
            barPercentage: 1, // 30px width for each bar
            categoryPercentage: 0.85, // Controls spacing between groups of bars
          },
          {
            label: "Блокировка",
            data: [],
            backgroundColor: "#F23030", // Красный
            borderRadius: 10,
            barPercentage: 1, // 30px width for each bar
            categoryPercentage: 0.85, // Controls spacing between groups of bars
          },
          {
            label: "Пищевая Безопасность",
            data: [],
            backgroundColor: "#6B7280", // Серый
            borderRadius: 10,
            barPercentage: 1, // 30px width for each bar
            categoryPercentage: 0.85, // Controls spacing between groups of bars
          },
          {
            label: "Качество Упаковки",
            data: [],
            backgroundColor: "#d629b1",
            borderRadius: 10,
            barPercentage: 1, // 30px width for each bar
            categoryPercentage: 0.85, // Controls spacing between groups of bars
          },
          {
            label: "Сенсорика",
            data: [],
            backgroundColor: "#1597cf",
            borderRadius: 10,
            barPercentage: 1, // 30px width for each bar
            categoryPercentage: 0.85, // Controls spacing between groups of bars
          },
          {
            label: "Другое",
            data: [],
            backgroundColor: "#83cc9b",
            borderRadius: 10,
            barPercentage: 1, // 30px width for each bar
            categoryPercentage: 0.85, // Controls spacing between groups of bars
          },
        ],
      });
      setChartMData({
        labels: [],
        datasets: [
          {
            label: "Механика",
            data: [],
            backgroundColor: "#F2A900", // Желтый
            borderRadius: 10,
            barPercentage: 1, // 30px width for each bar
            categoryPercentage: 0.85, // Controls spacing between groups of bars
          },
          {
            label: "Электрика",
            data: [],
            backgroundColor: "#1A8245", // Зеленый
            borderRadius: 10,
            barPercentage: 1, // 30px width for each bar
            categoryPercentage: 0.85, // Controls spacing between groups of bars
          },
          {
            label: "Электроавтоматика",
            data: [],
            backgroundColor: "#F23030", // Красный
            borderRadius: 10,
            barPercentage: 1, // 30px width for each bar
            categoryPercentage: 0.85, // Controls spacing between groups of bars
          },
          {
            label: "Технолог персонал",
            data: [],
            backgroundColor: "#6B7280", // Серый
            borderRadius: 10,
            barPercentage: 1, // 30px width for each bar
            categoryPercentage: 0.85, // Controls spacing between groups of bars
          },
          {
            label: "Здания, коммуникации",
            data: [],
            backgroundColor: "#d629b1",
            borderRadius: 10,
            barPercentage: 1, // 30px width for each bar
            categoryPercentage: 0.85, // Controls spacing between groups of bars
          },
          {
            label: "Другие",
            data: [],
            backgroundColor: "#83cc9b",
            borderRadius: 10,
            barPercentage: 1, // 30px width for each bar
            categoryPercentage: 0.85, // Controls spacing between groups of bars
          },
        ],
      });
      setChartMActionsData({});
      getItemsRequest({
        listName: myTasksIncidentstListName,
        rowLimit: 25,
        filters,
        sortOrder: { name: "DateIncidents", desc: true },
      }).then((results: any) => {
        const { items, nextPage } = results;
        if (items.length > 0) {
          let incIds: string[] = [];
          let requests5Way: any = [];
          items.map((item: any) => {
            requests5Way = [
              ...requests5Way,
              getItemsRequest({
                listName: myTasks5WayListName,
                filters: { Incident: item.ID },
              }),
            ];
          });
          Promise.all(requests5Way).then((values: any) => {
            let cards5Way: any = [],
              deviationCardsIds: any = [];
            values.map((results: any) => {
              cards5Way = [...cards5Way, ...results["items"]];
            });
            cards5Way
              .filter(
                (card5Way: any) => card5Way.Type5Way === "DeviationReport"
              )
              .map((card5Way: any) => {
                deviationCardsIds = [...deviationCardsIds, card5Way.ID];
              });
            Promise.all([
              getItemsRequest({
                listName: myTasksSDCA5WayListName,
                filters: {
                  _x0035_Way: (deviationCardsIds.length > 0 &&
                    deviationCardsIds) || [0],
                },
                method: '/api/sdca5-way/search'
              }),
            ]).then((values: any) => {
              let arrRequests: any = [];
              let sdcaItemsAll: any = {
                deviationCards: [],
              };
              values.map((results: any, idx: number) => {
                sdcaItemsAll["deviationCards"] = [...results.items];
                const sdcaItems = [...results.items];
                sdcaItems.map((item) => {
                  arrRequests = [
                    ...arrRequests,
                    getItemsRequest({
                      listName: myTaskActionsListName,
                      filters: {
                        ImportantHashTag: `#Отчет_об_отклонениях_${item.ID}*`,
                      },
                    }),
                  ];
                });
              });
              Promise.all(arrRequests).then((values) => {
                let actions: any = [];
                values.map((value) => {
                  actions = [...actions, ...value.items];
                });
                const returnItemsDeviationCards = cards5Way
                  .filter(
                    (card5Way: any) => card5Way.Type5Way === "DeviationReport"
                  )
                  .map((item: any) => {
                    const currentSdcaItems = sdcaItemsAll[
                      "deviationCards"
                    ].filter(
                      (sdcaItem: any) =>
                        sdcaItem._x0035_Way.get_lookupId() === item.ID
                    );
                    let currentActions: any = [];
                    currentSdcaItems.map((currentSdcaItem: any) => {
                      currentActions = [
                        ...currentActions,
                        ...actions.filter(
                          (action: any) =>
                            action.ImportantHashTag.indexOf(
                              `#Отчет_об_отклонениях_${currentSdcaItem.ID}`
                            ) !== -1
                        ),
                      ];
                    });
                    return {
                      ...item,
                      actions: currentActions,
                    };
                  });
                const cards5WayData = [...returnItemsDeviationCards];
                getItemsRequest({
                  listName: myTaskActionsListName,
                  viewFields: [
                    "ID",
                    "Description",
                    "ImportantHashTag",
                    "Status",
                  ],
                  filters: {
                    ImportantHashTag: (incIds.length > 0 && incIds) || ["0"],
                  },
                }).then((results) => {
                  let actions = [...results.items],
                    actionsIncStatus: any = {
                      name: "В процессе",
                      color: "#F2A900",
                    };
                  let returnItems = items.map((item: any) => {
                    let currentActions: any = [];
                    const card5WayInc =
                      (cards5WayData.filter(
                        (card5way: any) =>
                          card5way.Incident.get_lookupId() === item.ID
                      ).length > 0 &&
                        cards5WayData.filter(
                          (card5way: any) =>
                            card5way.Incident.get_lookupId() === item.ID
                        )[0]) ||
                      null;
                    if (card5WayInc) {
                      currentActions = [
                        ...currentActions,
                        ...card5WayInc["actions"],
                      ];
                    }
                    if (currentActions.length === 0) {
                      actionsIncStatus = {
                        name: "Нет действий",
                        color: "#FDE5D8",
                      };
                    } else if (
                      currentActions.length > 0 &&
                      currentActions.some(
                        (action: any) =>
                          action.Status.get_lookupId() === actionsStatus.old
                      )
                    ) {
                      actionsIncStatus = {
                        name: "Просрочено",
                        color: "#F23030",
                      };
                    } else if (
                      currentActions.length > 0 &&
                      currentActions.filter(
                        (action: any) =>
                          action.Status.get_lookupId() === actionsStatus.cancel
                      ).length === currentActions.length
                    ) {
                      actionsIncStatus = { name: "Отменено", color: "#6B7280" };
                    } else if (
                      currentActions.length > 0 &&
                      currentActions.filter(
                        (action: any) =>
                          action.Status.get_lookupId() === actionsStatus.closed
                      ).length === currentActions.length
                    ) {
                      actionsIncStatus = { name: "Закрыто", color: "#22AD5C" };
                    } else if (
                      currentActions.length > 0 &&
                      currentActions.filter(
                        (action: any) =>
                          action.Status.get_lookupId() ===
                          actionsStatus.notStart
                      ).length === currentActions.length
                    ) {
                      actionsIncStatus = {
                        name: "Не начато",
                        color: "#FDE5D8",
                      };
                    } else if (
                      currentActions.length > 0 &&
                      (currentActions.some(
                        (action: any) =>
                          action.Status.get_lookupId() === actionsStatus.cancel
                      ) ||
                        currentActions.some(
                          (action: any) =>
                            action.Status.get_lookupId() ===
                            actionsStatus.closed
                        )) &&
                      currentActions.filter(
                        (action: any) =>
                          action.Status.get_lookupId() === actionsStatus.old
                      ).length === 0 &&
                      currentActions.filter(
                        (action: any) =>
                          action.Status.get_lookupId() === actionsStatus.process
                      ).length === 0 &&
                      currentActions.filter(
                        (action: any) =>
                          action.Status.get_lookupId() ===
                          actionsStatus.notStart
                      ).length === 0
                    ) {
                      actionsIncStatus = { name: "Закрыто", color: "#22AD5C" };
                    } else if (
                      currentActions.length > 0 &&
                      currentActions.filter(
                        (action: any) =>
                          action.Status.get_lookupId() === actionsStatus.old
                      ).length === 0 &&
                      currentActions.filter(
                        (action: any) =>
                          action.Status.get_lookupId() === actionsStatus.process
                      ).length > 0
                    ) {
                      actionsIncStatus = {
                        name: "В процессе",
                        color: "#F2A900",
                      };
                    }
                    return {
                      ...item,
                      actions: currentActions,
                      actionsIncStatus,
                    };
                  });
                  setTempIncidents([...returnItems]);
                  setGegIncidents(true);
                  if (items.length === 25) {
                    setNextPage(nextPage);
                  } else {
                    setNextPage(false);
                  }
                });
              });
            });
          });
        } else {
          setTempIncidents([]);
          setIncidents([]);
          setGegIncidents(true);
          setNextPage(null);
        }
      });
    }
  }, [filters]);

  //Получение инцидентов по nextPage
  useEffect(() => {
    if (nextPage && getIncidents) {
      getItemsRequest({
        listName: myTasksIncidentstListName,
        rowLimit: 25,
        filters,
        nextPage,
        sortOrder: { name: "DateIncidents", desc: true },
      }).then((results: any) => {
        const { items, nextPage } = results;
        let incIds: string[] = [];
        let requests5Way: any = [];
        items.map((item: any) => {
          requests5Way = [
            ...requests5Way,
            getItemsRequest({
              listName: myTasks5WayListName,
              filters: { Incident: item.ID },
            }),
          ];
        });
        Promise.all(requests5Way).then((values: any) => {
          let cards5Way: any = [],
            deviationCardsIds: any = [];
          values.map((results: any) => {
            cards5Way = [...cards5Way, ...results["items"]];
          });
          cards5Way
            .filter((card5Way: any) => card5Way.Type5Way === "DeviationReport")
            .map((card5Way: any) => {
              deviationCardsIds = [...deviationCardsIds, card5Way.ID];
            });
          Promise.all([
            getItemsRequest({
              listName: myTasksSDCA5WayListName,
              filters: {
                _x0035_Way: (deviationCardsIds.length > 0 &&
                  deviationCardsIds) || [0],
              },
              method: '/api/sdca5-way/search'
            }),
          ]).then((values: any) => {
            let arrRequests: any = [];
            let sdcaItemsAll: any = {
              deviationCards: [],
            };
            values.map((results: any, idx: number) => {
              sdcaItemsAll["deviationCards"] = [...results.items];
              const sdcaItems = [...results.items];
              sdcaItems.map((item) => {
                arrRequests = [
                  ...arrRequests,
                  getItemsRequest({
                    listName: myTaskActionsListName,
                    filters: {
                      ImportantHashTag: `#Отчет_об_отклонениях_${item.ID}*`,
                    },
                  }),
                ];
              });
            });
            Promise.all(arrRequests).then((values) => {
              let actions: any = [];
              values.map((value) => {
                actions = [...actions, ...value.items];
              });
              const returnItemsDeviationCards = cards5Way
                .filter(
                  (card5Way: any) => card5Way.Type5Way === "DeviationReport"
                )
                .map((item: any) => {
                  const currentSdcaItems = sdcaItemsAll[
                    "deviationCards"
                  ].filter(
                    (sdcaItem: any) =>
                      sdcaItem._x0035_Way.get_lookupId() === item.ID
                  );
                  let currentActions: any = [];
                  currentSdcaItems.map((currentSdcaItem: any) => {
                    currentActions = [
                      ...currentActions,
                      ...actions.filter(
                        (action: any) =>
                          action.ImportantHashTag.indexOf(
                            `#Отчет_об_отклонениях_${currentSdcaItem.ID}`
                          ) !== -1
                      ),
                    ];
                  });
                  return {
                    ...item,
                    actions: currentActions,
                  };
                });
              const cards5WayData = [...returnItemsDeviationCards];
              getItemsRequest({
                listName: myTaskActionsListName,
                viewFields: ["ID", "Description", "ImportantHashTag", "Status"],
                filters: {
                  ImportantHashTag: (incIds.length > 0 && incIds) || ["0"],
                },
              }).then((results) => {
                let actions = [...results.items],
                  actionsIncStatus: any = {
                    name: "В процессе",
                    color: "#F2A900",
                  };
                let returnItems = items.map((item: any) => {
                  let currentActions: any = [];
                  const card5WayInc =
                    (cards5WayData.filter(
                      (card5way: any) =>
                        card5way.Incident.get_lookupId() === item.ID
                    ).length > 0 &&
                      cards5WayData.filter(
                        (card5way: any) =>
                          card5way.Incident.get_lookupId() === item.ID
                      )[0]) ||
                    null;
                  if (card5WayInc) {
                    currentActions = [
                      ...currentActions,
                      ...card5WayInc["actions"],
                    ];
                  }
                  if (currentActions.length === 0) {
                    actionsIncStatus = {
                      name: "Нет действий",
                      color: "#FDE5D8",
                    };
                  } else if (
                    currentActions.length > 0 &&
                    currentActions.some(
                      (action: any) =>
                        action.Status.get_lookupId() === actionsStatus.old
                    )
                  ) {
                    actionsIncStatus = { name: "Просрочено", color: "#F23030" };
                  } else if (
                    currentActions.length > 0 &&
                    currentActions.filter(
                      (action: any) =>
                        action.Status.get_lookupId() === actionsStatus.cancel
                    ).length === currentActions.length
                  ) {
                    actionsIncStatus = { name: "Отменено", color: "#6B7280" };
                  } else if (
                    currentActions.length > 0 &&
                    currentActions.filter(
                      (action: any) =>
                        action.Status.get_lookupId() === actionsStatus.closed
                    ).length === currentActions.length
                  ) {
                    actionsIncStatus = { name: "Закрыто", color: "#22AD5C" };
                  } else if (
                    currentActions.length > 0 &&
                    currentActions.filter(
                      (action: any) =>
                        action.Status.get_lookupId() === actionsStatus.notStart
                    ).length === currentActions.length
                  ) {
                    actionsIncStatus = { name: "Не начато", color: "#FDE5D8" };
                  } else if (
                    currentActions.length > 0 &&
                    (currentActions.some(
                      (action: any) =>
                        action.Status.get_lookupId() === actionsStatus.cancel
                    ) ||
                      currentActions.some(
                        (action: any) =>
                          action.Status.get_lookupId() === actionsStatus.closed
                      )) &&
                    currentActions.filter(
                      (action: any) =>
                        action.Status.get_lookupId() === actionsStatus.old
                    ).length === 0 &&
                    currentActions.filter(
                      (action: any) =>
                        action.Status.get_lookupId() === actionsStatus.process
                    ).length === 0 &&
                    currentActions.filter(
                      (action: any) =>
                        action.Status.get_lookupId() === actionsStatus.notStart
                    ).length === 0
                  ) {
                    actionsIncStatus = { name: "Закрыто", color: "#22AD5C" };
                  } else if (
                    currentActions.length > 0 &&
                    currentActions.filter(
                      (action: any) =>
                        action.Status.get_lookupId() === actionsStatus.old
                    ).length === 0 &&
                    currentActions.filter(
                      (action: any) =>
                        action.Status.get_lookupId() === actionsStatus.process
                    ).length > 0
                  ) {
                    actionsIncStatus = { name: "В процессе", color: "#F2A900" };
                  }
                  return {
                    ...item,
                    actions: currentActions,
                    actionsIncStatus,
                  };
                });
                setTempIncidents((prevState: any) => [
                  ...prevState,
                  ...returnItems,
                ]);
                if (items.length === 25) {
                  setNextPage(nextPage);
                } else {
                  setNextPage(false);
                }
              });
            });
          });
        });
      });
    }
  }, [nextPage]);

  useEffect(() => {
    if (tempIncidents.length > 0) {
      let localTempInc: any = [];
      localTempInc = [...tempIncidents];
      let incWithQuestions: any = [];
      localTempInc.forEach((incItem: any) => {
        if (incItem.Questions) {
          incWithQuestions = [
            ...incWithQuestions,
            { ...incItem, ...JSON.parse(incItem.Questions) },
          ];
        }
      });
      setIncidents([..._.uniqWith(incWithQuestions, _.isEqual)]);
    }
  }, [tempIncidents]);

  useEffect(() => {
    console.log("incidents: ", incidents);
    let dataSetYearIncidents: any = {
      process: [],
      closed: [],
      overdue: [],
      canceled: [],
    };
    let dataSetFactoryIncidents: any = {
      process: [],
      closed: [],
      overdue: [],
      canceled: [],
    };
    let dataSetQualityIncidents: any = {
      1: [],
      2: [],
      3: [],
      4: [],
      5: [],
      6: [],
      7: [],
    };
    let dataSetMIncidents: any = {
      1: [],
      2: [],
      3: [],
      4: [],
      5: [],
      6: [],
    };
    let dataSetMonth: any = {};
    let dataSetFactory: any = {};
    let dataSetQuality: any = {};
    let dataSetM: any = {};

    let incidentsPeriodSort = incidents
      .filter(
        (item: any) =>
          moment(item.DateIncidents).unix() > period.start &&
          moment(item.DateIncidents).unix() < period.end
      )
      .sort((a: any, b: any) =>
        a.Location.get_lookupValue().localeCompare(b.Location.get_lookupValue())
      );

    let incidentsYearSort = incidents
      .filter(
        (item: any) =>
          moment(item.DateIncidents).format("YYYY") ===
          moment(year).format("YYYY")
      )
      .sort(
        (a: any, b: any) =>
          Number(moment(a.DateIncidents).format("M")) <
          Number(moment(b.DateIncidents).format("M"))
      );

    incidentsYearSort.map((item: any) => {
      if (!Array.isArray(dataSetMonth[item.DateIncidents.getMonth() + 1])) {
        dataSetMonth[item.DateIncidents.getMonth() + 1] = [];
      }
      dataSetMonth[item.DateIncidents.getMonth() + 1] = [
        ...dataSetMonth[item.DateIncidents.getMonth() + 1],
        item,
      ];
    });
    let actionsObjLocations: any = {};
    let tempChartMActionsData: any = {};
    incidentsPeriodSort.map((item: any) => {
      if (!Array.isArray(dataSetFactory[item.Location.get_lookupValue()])) {
        dataSetFactory[item.Location.get_lookupValue()] = [];
      }
      if (!Array.isArray(dataSetM[item.Location.get_lookupValue()])) {
        dataSetM[item.Location.get_lookupValue()] = [];
      }
      if (
        !tempChartMActionsData.hasOwnProperty(item.Location.get_lookupValue())
      ) {
        tempChartMActionsData[item.Location.get_lookupValue()] = {
          process: 0,
          overdue: 0,
        };
      }
      if (
        !Array.isArray(actionsObjLocations[item.Location.get_lookupValue()])
      ) {
        actionsObjLocations[item.Location.get_lookupValue()] = [];
      }
      if (!Array.isArray(dataSetQuality[item.DateIncidents.getMonth() + 1])) {
        dataSetQuality[item.DateIncidents.getMonth() + 1] = [];
      }
      dataSetFactory[item.Location.get_lookupValue()] = [
        ...dataSetFactory[item.Location.get_lookupValue()],
        item,
      ];
      dataSetM[item.Location.get_lookupValue()] = [
        ...dataSetM[item.Location.get_lookupValue()],
        item,
      ];
      dataSetQuality[item.DateIncidents.getMonth() + 1] = [
        ...dataSetQuality[item.DateIncidents.getMonth() + 1],
        item,
      ];
      actionsObjLocations[item.Location.get_lookupValue()] = [
        ...actionsObjLocations[item.Location.get_lookupValue()],
        ...item.actions,
      ];
    });
    if (filters.TypeIncident === incTypes.m) {
      Object.keys(actionsObjLocations).forEach((key) => {
        if (actionsObjLocations[key].length > 0) {
          tempChartMActionsData[key] = {
            process: actionsObjLocations[key].filter(
              (action: any) =>
                action.Status.get_lookupId() === actionsStatus.process
            ).length,
            overdue: actionsObjLocations[key].filter(
              (action: any) =>
                action.Status.get_lookupId() === actionsStatus.old
            ).length,
          };
        }
      });
      setChartMActionsData({ ...tempChartMActionsData });
    }
    let tempChartQualityData = { ...chartQualityData };
    let tempChartMData = { ...chartMData };

    if (filters.TypeIncident === incTypes.q) {
      dataSetQualityIncidents["1"] = Object.keys(dataSetQuality).map(
        (key) =>
          dataSetQuality[key].filter(
            (item: any) =>
              (item.QAProcessIncidentCategory &&
                item.QAProcessIncidentCategory.name === "Физико-химия") ||
              (item.QAIncidentCategory &&
                item.QAIncidentCategory.name === "Физико-химия")
          ).length
      );
      dataSetQualityIncidents["2"] = Object.keys(dataSetQuality).map(
        (key) =>
          dataSetQuality[key].filter(
            (item: any) =>
              (item.QAProcessIncidentCategory &&
                item.QAProcessIncidentCategory.name === "Микробиология") ||
              (item.QAIncidentCategory &&
                item.QAIncidentCategory.name === "Микробиология")
          ).length
      );
      dataSetQualityIncidents["3"] = Object.keys(dataSetQuality).map(
        (key) =>
          dataSetQuality[key].filter(
            (item: any) =>
              (item.QAProcessIncidentCategory &&
                item.QAProcessIncidentCategory.name === "Блокировка") ||
              (item.QAIncidentCategory &&
                item.QAIncidentCategory.name === "Блокировка")
          ).length
      );
      dataSetQualityIncidents["4"] = Object.keys(dataSetQuality).map(
        (key) =>
          dataSetQuality[key].filter(
            (item: any) =>
              (item.QAProcessIncidentCategory &&
                item.QAProcessIncidentCategory.name ===
                "Пищевая Безопасность") ||
              (item.QAIncidentCategory &&
                item.QAIncidentCategory.name === "Пищевая Безопасность")
          ).length
      );
      dataSetQualityIncidents["5"] = Object.keys(dataSetQuality).map(
        (key) =>
          dataSetQuality[key].filter(
            (item: any) =>
              (item.QAProcessIncidentCategory &&
                item.QAProcessIncidentCategory.name === "Качество Упаковки") ||
              (item.QAIncidentCategory &&
                item.QAIncidentCategory.name === "Качество Упаковки")
          ).length
      );
      dataSetQualityIncidents["6"] = Object.keys(dataSetQuality).map(
        (key) =>
          dataSetQuality[key].filter(
            (item: any) =>
              (item.QAProcessIncidentCategory &&
                item.QAProcessIncidentCategory.name === "Сенсорика") ||
              (item.QAIncidentCategory &&
                item.QAIncidentCategory.name === "Сенсорика")
          ).length
      );
      dataSetQualityIncidents["7"] = Object.keys(dataSetQuality).map(
        (key) =>
          dataSetQuality[key].filter(
            (item: any) =>
              (item.QAProcessIncidentCategory &&
                item.QAProcessIncidentCategory.name === "Другое") ||
              (item.QAIncidentCategory &&
                item.QAIncidentCategory.name === "Другое")
          ).length
      );

      let largeQuality: number[] = [];
      Object.keys(dataSetQualityIncidents).map((key, idx) => {
        largeQuality = [
          ...largeQuality,
          Math.max.apply(Math, dataSetQualityIncidents[key]),
        ];
        tempChartQualityData["datasets"][idx]["data"] =
          dataSetQualityIncidents[key];
      });
      setMaxQuality(Math.max.apply(Math, largeQuality));
    }

    if (filters.TypeIncident === incTypes.m) {
      dataSetMIncidents["1"] = Object.keys(dataSetQuality).map(
        (key) =>
          dataSetQuality[key].filter(
            (item: any) =>
              item.MIncDirection && item.MIncDirection.name === "Механика"
          ).length
      );
      dataSetMIncidents["2"] = Object.keys(dataSetQuality).map(
        (key) =>
          dataSetQuality[key].filter(
            (item: any) =>
              item.MIncDirection && item.MIncDirection.name === "Электрика"
          ).length
      );
      dataSetMIncidents["3"] = Object.keys(dataSetQuality).map(
        (key) =>
          dataSetQuality[key].filter(
            (item: any) =>
              item.MIncDirection &&
              item.MIncDirection.name === "Электроавтоматика"
          ).length
      );
      dataSetMIncidents["4"] = Object.keys(dataSetQuality).map(
        (key) =>
          dataSetQuality[key].filter(
            (item: any) =>
              item.MIncDirection &&
              item.MIncDirection.name === "Технолог персонал"
          ).length
      );
      dataSetMIncidents["5"] = Object.keys(dataSetQuality).map(
        (key) =>
          dataSetQuality[key].filter(
            (item: any) =>
              item.MIncDirection &&
              item.MIncDirection.name === "Здания, коммуникации"
          ).length
      );
      dataSetMIncidents["6"] = Object.keys(dataSetQuality).map(
        (key) =>
          dataSetQuality[key].filter(
            (item: any) =>
              item.MIncDirection && item.MIncDirection.name === "Другие"
          ).length
      );

      let largeM: number[] = [];
      Object.keys(dataSetMIncidents).map((key, idx) => {
        largeM = [...largeM, Math.max.apply(Math, dataSetMIncidents[key])];
        tempChartMData["datasets"][idx]["data"] = dataSetMIncidents[key];
      });
      setMaxM(Math.max.apply(Math, largeM));
    }

    dataSetYearIncidents["process"] = Object.keys(dataSetMonth).map(
      (key) =>
        dataSetMonth[key].filter(
          (item: any) => item.Status.get_lookupId() === incStatus.process
        ).length
    );
    dataSetYearIncidents["closed"] = Object.keys(dataSetMonth).map(
      (key) =>
        dataSetMonth[key].filter(
          (item: any) => item.Status.get_lookupId() === incStatus.finish
        ).length
    );
    dataSetYearIncidents["overdue"] = Object.keys(dataSetMonth).map(
      (key) =>
        dataSetMonth[key].filter(
          (item: any) => item.Status.get_lookupId() === incStatus.old
        ).length
    );
    dataSetYearIncidents["canceled"] = Object.keys(dataSetMonth).map(
      (key) =>
        dataSetMonth[key].filter(
          (item: any) => item.Status.get_lookupId() === incStatus.cancel
        ).length
    );

    dataSetFactoryIncidents["process"] = Object.keys(dataSetFactory).map(
      (key) =>
        dataSetFactory[key].filter(
          (item: any) => item.Status.get_lookupId() === incStatus.process
        ).length
    );
    dataSetFactoryIncidents["closed"] = Object.keys(dataSetFactory).map(
      (key) =>
        dataSetFactory[key].filter(
          (item: any) => item.Status.get_lookupId() === incStatus.finish
        ).length
    );
    dataSetFactoryIncidents["overdue"] = Object.keys(dataSetFactory).map(
      (key) =>
        dataSetFactory[key].filter(
          (item: any) => item.Status.get_lookupId() === incStatus.old
        ).length
    );
    dataSetFactoryIncidents["canceled"] = Object.keys(dataSetFactory).map(
      (key) =>
        dataSetFactory[key].filter(
          (item: any) => item.Status.get_lookupId() === incStatus.cancel
        ).length
    );

    let tempFactoryLabels: any = [];
    Object.keys(dataSetFactory).map((key: string) => {
      tempFactoryLabels = [...tempFactoryLabels, key];
    });

    let tempChartYearData = { ...chartYearData };
    let largeYear: number[] = [];
    Object.keys(dataSetYearIncidents).map((key, idx) => {
      largeYear = [
        ...largeYear,
        Math.max.apply(Math, dataSetYearIncidents[key]),
      ];
      tempChartYearData["datasets"][idx]["data"] = dataSetYearIncidents[key];
    });
    setMaxYMonth(Math.max.apply(Math, largeYear));

    let tempChartFactoryData = { ...chartFactoryData };
    let largeFactory: number[] = [];
    Object.keys(dataSetFactoryIncidents).map((key, idx) => {
      largeFactory = [
        ...largeFactory,
        Math.max.apply(Math, dataSetFactoryIncidents[key]),
      ];
      tempChartFactoryData["datasets"][idx]["data"] =
        dataSetFactoryIncidents[key];
    });
    setMaxFactory(Math.max.apply(Math, largeFactory));

    let tempMonthLabels: any = [];
    Object.keys(dataSetMonth).map((key: string) => {
      tempMonthLabels = [...tempMonthLabels, months[Number(key) - 1]];
    });

    let tempQuailityLabels: any = [];
    Object.keys(dataSetQuality).map((key: string) => {
      tempQuailityLabels = [...tempQuailityLabels, months[Number(key) - 1]];
    });

    let tempMLabels: any = [];
    Object.keys(dataSetM).map((key: string) => {
      tempMLabels = [...tempMLabels, key];
    });

    if (!nextPage && getIncidents) {
      setChartFactoryData({ ...tempChartFactoryData });
      setChartYearData({ ...tempChartYearData });
      setChartQualityData({ ...tempChartQualityData });
      setChartMData({ ...tempChartMData });
      setFactoriesLabels([...tempFactoryLabels]);
      setMonthLabels([...tempMonthLabels]);
      setQualityLabels([...tempQuailityLabels]);
      setMLabels([...tempMLabels]);
      setCustomLoading(false);
    }
  }, [incidents, year]);

  useEffect(() => {
    let tempParamsY: any = { ...chartYOptions };
    let tempParamsPeriod: any = { ...chartPeriodOptions };
    tempParamsY["scales"]["y"]["max"] = Math.ceil(maxYMonth / 10) * 10 + 10;
    tempParamsPeriod["scales"]["y"]["max"] =
      Math.ceil(maxFactory / 10) * 10 + 10;
    setChartYOptions({ ...tempParamsY });
    setChartPeriodOptions({ ...tempParamsPeriod });
    if (filters.TypeIncident === 3) {
      let tempParamsQuality: any = { ...chartQualityOptions };
      tempParamsQuality["scales"]["y"]["max"] =
        Math.ceil(maxQuality / 10) * 10 + 10;
      setChartQualityOptions({ ...tempParamsQuality });
    }
    if (filters.TypeIncident === incTypes.m) {
      let tempParamsM: any = { ...chartMOptions };
      tempParamsM["scales"]["y"]["max"] = Math.ceil(maxM / 10) * 10 + 10;
      setChartMOptions({ ...tempParamsM });
    }
  }, [maxYMonth, maxFactory, maxQuality, maxM]);

  useEffect(() => {
    if (typesIncList.length > 0) {
      setTypesInc(
        typesIncList.filter((type: any) => type.ID !== incTypes.security)
      );
    }
  }, [typesIncList]);

  useEffect(() => {
    const tempFieldsForm: any = [...fieldsSendEmails];
    for (let i = 0; i < tempFieldsForm.length; i++) {
      if (tempFieldsForm[i]["key"] === "TypeIncident") {
        tempFieldsForm[i]["optionsInputs"] =
          typesInc.map((type: any) => type.Title.trim()) || [];
      }
    }
    setFieldsSetEmails([...tempFieldsForm]);
  }, [typesInc]);

  useEffect(() => {
    if (formDataSendEmails && Object.keys(formDataSendEmails).length > 0) {
      setTempScreenData({});
      setTempScrenLabels([]);
      setLoadingSetEmail(true);
      let filterIncEmails: any = { Questions: [`"IncidentOption":"Инцидент"`] },
        idCurrentTypeInc: any,
        localIncDateEmails: any;
      Object.keys(formDataSendEmails).map((key) => {
        if (key === "DateIncidents") {
          localIncDateEmails = {
            start: moment(formDataSendEmails[key].startDate).unix(),
            end: moment(formDataSendEmails[key].endDate).unix(),
            endDate: moment(formDataSendEmails[key].endDate),
          };
        } else if (key === "TypeIncident") {
          idCurrentTypeInc = typesInc.filter(
            (type: any) => type.Title === formDataSendEmails[key]
          )[0]["ID"];
          filterIncEmails[key] = idCurrentTypeInc;
        }
      });
      getItemsRequest({
        listName: myTasksIncidentstListName,
        filters: filterIncEmails,
        sortOrder: { name: "DateIncidents", desc: true },
      }).then((results: any) => {
        const { items } = results;
        let incIds: string[] = [];
        let requests5Way: any = [];
        items.map((item: any) => {
          requests5Way = [
            ...requests5Way,
            getItemsRequest({
              listName: myTasks5WayListName,
              filters: { Incident: item.ID },
            }),
          ];
        });
        Promise.all(requests5Way).then((values: any) => {
          let cards5Way: any = [],
            deviationCardsIds: any = [];
          values.map((results: any) => {
            cards5Way = [...cards5Way, ...results["items"]];
          });
          cards5Way
            .filter((card5Way: any) => card5Way.Type5Way === "DeviationReport")
            .map((card5Way: any) => {
              deviationCardsIds = [...deviationCardsIds, card5Way.ID];
            });
          Promise.all([
            getItemsRequest({
              listName: myTasksSDCA5WayListName,
              filters: {
                _x0035_Way: (deviationCardsIds.length > 0 &&
                  deviationCardsIds) || [0],
              },
              method: '/api/sdca5-way/search'
            }),
          ]).then((values: any) => {
            let arrRequests: any = [];
            let sdcaItemsAll: any = {
              deviationCards: [],
            };
            values.map((results: any, idx: number) => {
              sdcaItemsAll["deviationCards"] = [...results.items];
              const sdcaItems = [...results.items];
              sdcaItems.map((item) => {
                arrRequests = [
                  ...arrRequests,
                  getItemsRequest({
                    listName: myTaskActionsListName,
                    filters: {
                      ImportantHashTag: `#Отчет_об_отклонениях_${item.ID}*`,
                    },
                  }),
                ];
              });
            });
            Promise.all(arrRequests).then((values) => {
              let actions: any = [];
              values.map((value) => {
                actions = [...actions, ...value.items];
              });
              const returnItemsDeviationCards = cards5Way
                .filter(
                  (card5Way: any) => card5Way.Type5Way === "DeviationReport"
                )
                .map((item: any) => {
                  const currentSdcaItems = sdcaItemsAll[
                    "deviationCards"
                  ].filter(
                    (sdcaItem: any) =>
                      sdcaItem._x0035_Way.get_lookupId() === item.ID
                  );
                  let currentActions: any = [];
                  currentSdcaItems.map((currentSdcaItem: any) => {
                    currentActions = [
                      ...currentActions,
                      ...actions.filter(
                        (action: any) =>
                          action.ImportantHashTag.indexOf(
                            `#Отчет_об_отклонениях_${currentSdcaItem.ID}`
                          ) !== -1
                      ),
                    ];
                  });
                  return {
                    ...item,
                    actions: currentActions,
                  };
                });
              const cards5WayData = [...returnItemsDeviationCards];
              let actionsIncStatus: any = {
                name: "В процессе",
                color: "#F2A900",
              };
              let returnItems = items.map((item: any) => {
                let currentActions: any = [];
                const card5WayInc =
                  (cards5WayData.filter(
                    (card5way: any) =>
                      card5way.Incident.get_lookupId() === item.ID
                  ).length > 0 &&
                    cards5WayData.filter(
                      (card5way: any) =>
                        card5way.Incident.get_lookupId() === item.ID
                    )[0]) ||
                  null;
                if (card5WayInc) {
                  currentActions = [
                    ...currentActions,
                    ...card5WayInc["actions"],
                  ];
                }
                if (currentActions.length === 0) {
                  actionsIncStatus = { name: "Нет действий", color: "#FDE5D8" };
                } else if (
                  currentActions.length > 0 &&
                  currentActions.some(
                    (action: any) =>
                      action.Status.get_lookupId() === actionsStatus.old
                  )
                ) {
                  actionsIncStatus = { name: "Просрочено", color: "#F23030" };
                } else if (
                  currentActions.length > 0 &&
                  currentActions.filter(
                    (action: any) =>
                      action.Status.get_lookupId() === actionsStatus.cancel
                  ).length === currentActions.length
                ) {
                  actionsIncStatus = { name: "Отменено", color: "#6B7280" };
                } else if (
                  currentActions.length > 0 &&
                  currentActions.filter(
                    (action: any) =>
                      action.Status.get_lookupId() === actionsStatus.closed
                  ).length === currentActions.length
                ) {
                  actionsIncStatus = { name: "Закрыто", color: "#22AD5C" };
                } else if (
                  currentActions.length > 0 &&
                  currentActions.filter(
                    (action: any) =>
                      action.Status.get_lookupId() === actionsStatus.notStart
                  ).length === currentActions.length
                ) {
                  actionsIncStatus = { name: "Не начато", color: "#FDE5D8" };
                } else if (
                  currentActions.length > 0 &&
                  (currentActions.some(
                    (action: any) =>
                      action.Status.get_lookupId() === actionsStatus.cancel
                  ) ||
                    currentActions.some(
                      (action: any) =>
                        action.Status.get_lookupId() === actionsStatus.closed
                    )) &&
                  currentActions.filter(
                    (action: any) =>
                      action.Status.get_lookupId() === actionsStatus.old
                  ).length === 0 &&
                  currentActions.filter(
                    (action: any) =>
                      action.Status.get_lookupId() === actionsStatus.process
                  ).length === 0 &&
                  currentActions.filter(
                    (action: any) =>
                      action.Status.get_lookupId() === actionsStatus.notStart
                  ).length === 0
                ) {
                  actionsIncStatus = { name: "Закрыто", color: "#22AD5C" };
                } else if (
                  currentActions.length > 0 &&
                  currentActions.filter(
                    (action: any) =>
                      action.Status.get_lookupId() === actionsStatus.old
                  ).length === 0 &&
                  currentActions.filter(
                    (action: any) =>
                      action.Status.get_lookupId() === actionsStatus.process
                  ).length > 0
                ) {
                  actionsIncStatus = { name: "В процессе", color: "#F2A900" };
                }
                return {
                  ...item,
                  actions: currentActions,
                  processActionsCount: currentActions.filter(
                    (action: any) =>
                      action.Status.get_lookupId() === actionsStatus.process
                  ).length,
                  overdueActionsCount: currentActions.filter(
                    (action: any) =>
                      action.Status.get_lookupId() === actionsStatus.old
                  ).length,
                  actionsIncStatus,
                };
              });
              let localTempInc: any = [];
              localTempInc = [...returnItems];
              let incWithQuestions: any = [];
              localTempInc.forEach((incItem: any) => {
                if (incItem.Questions) {
                  incWithQuestions = [
                    ...incWithQuestions,
                    { ...incItem, ...JSON.parse(incItem.Questions) },
                  ];
                }
              });
              incWithQuestions = [..._.uniqWith(incWithQuestions, _.isEqual)];
              console.log("incWithQuestions: ", incWithQuestions);
              const timestamp = moment().unix();
              if (incWithQuestions.length > 0) {
                let tableStr = "";
                tableStr += `<p style="font-weight: bold; padding: 12px;">Ниже информация по инцидентам, зарегистрированным в период с ${formDataSendEmails["DateIncidents"].startDate
                  } по ${formDataSendEmails["DateIncidents"].endDate
                  } г:</p><table width="100%" cellspacing="0" cellpadding="8" border="0" style="border-collapse: collapse; background-color: #ffffff; box-shadow: 0 0 10px rgba(0,0,0,0.1);">
                <thead>
                    <tr>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">ID</th>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Дата регистрации</th>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Локация</th>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Отдел</th>
                        ${((idCurrentTypeInc === incTypes.safe ||
                    idCurrentTypeInc === incTypes.e) &&
                    `<th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Классификация инцидента</th>`) ||
                  ""
                  }
                        ${(idCurrentTypeInc === incTypes.safe &&
                    `<th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Тип SIF</th>`) ||
                  ""
                  }
                        ${(idCurrentTypeInc === incTypes.m &&
                    `<th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Участок</th><th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Название оборудования</th>`) ||
                  ""
                  }
                        ${(idCurrentTypeInc === incTypes.q &&
                    `<th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Инцидент в процессе/ по качеству</th>`) ||
                  ""
                  }
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Описание</th>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Статус инцидента</th>
                    </tr>
                </thead><tbody>`;
                incWithQuestions
                  .filter(
                    (item: any) =>
                      moment(item.DateIncidents).unix() >
                      localIncDateEmails.start &&
                      moment(item.DateIncidents).unix() < localIncDateEmails.end
                  )
                  .forEach((inc: any) => {
                    tableStr += `<tr>
                    <td style="background-color: #00629B; color: white; font-weight: bold; padding: 10px; border: 1px solid #ddd;">
                        <a href="${siteUrl}${urlDefault}/dashboard/3/incidents-and-nonconformities?incidentCard=${inc.ID
                      }&removeMail=${timestamp}" style="color: white; text-decoration: underline;">${inc.ID
                      }</a>
                    </td>
                    <td style="padding: 10px; border: 1px solid #ddd;">${moment(
                        inc.DateIncidents
                      ).format("DD.MM.YYYY")}</td>
                    <td style="padding: 10px; border: 1px solid #ddd;">${inc.Location.get_lookupValue()}</td>
                    <td style="padding: 10px; border: 1px solid #ddd;">${inc.Department.get_lookupValue()}</td>
                    ${((idCurrentTypeInc === incTypes.safe ||
                        idCurrentTypeInc === incTypes.e) &&
                        `<td style="padding: 10px; border: 1px solid #ddd;">${(idCurrentTypeInc === incTypes.e &&
                          inc.EnvIncClassification.name) ||
                        inc.SafeIncClassification.name
                        }</td>`) ||
                      ""
                      }
                    ${(idCurrentTypeInc === incTypes.safe &&
                        `<td style="padding: 10px; border: 1px solid #ddd;">${inc[
                        Object.keys(inc)
                          .map((key) => key)
                          .filter(
                            (key) => key.indexOf("SafeIncTypeSIF") !== -1
                          )[0]
                        ]
                        }</td>`) ||
                      ""
                      }
                     ${(idCurrentTypeInc === incTypes.m &&
                        `<td style="padding: 10px; border: 1px solid #ddd;">${inc.Region.get_lookupValue()}</td><td style="padding: 10px; border: 1px solid #ddd;">${inc.MIncEq[0]["SAP"]["Title"]
                        }</td>`) ||
                      ""
                      }
                        ${(idCurrentTypeInc === incTypes.q &&
                        `<td style="padding: 10px; border: 1px solid #ddd;">${inc["QAIncidentType"]}</td>`) ||
                      ""
                      }
                    <td style="padding: 10px; border: 1px solid #ddd;">${inc.Description
                      }</td>
                    <td style="padding: 10px; border: 1px solid #ddd; background-color: ${(isStrapi && inc.Status.get_metadata().Color) ||
                      inc.Status_x003a_Color.get_lookupValue()
                      }; text-align: center;">${inc.Status.get_lookupValue()}</td>
                </tr>`;
                  });
                tableStr += `</tbody></table>`;
                tableStr += `<br/>`;
                if (idCurrentTypeInc === incTypes.m) {
                  let incWithQuestionsMonth: any = incWithQuestions.filter(
                    (item: any) =>
                      moment(item.DateIncidents).unix() >
                      localIncDateEmails.endDate.startOf("M").unix() &&
                      moment(item.DateIncidents).unix() <
                      localIncDateEmails.endDate.endOf("M").unix()
                  );
                  let departmentsMonth = [
                    ..._.uniqWith(
                      incWithQuestionsMonth.map((item: any) =>
                        item.Department.get_lookupValue()
                      ),
                      _.isEqual
                    ),
                  ];
                  let locatioinsMonth = [
                    ..._.uniqWith(
                      incWithQuestionsMonth.map((item: any) =>
                        item.Location.get_lookupValue()
                      ),
                      _.isEqual
                    ),
                  ];
                  tableStr += `<p style="font-weight: bold; padding: 12px;">MTD ${localIncDateEmails.endDate.format(
                    "MMMM YYYY"
                  )}:</p><table width="100%" cellspacing="0" cellpadding="8" border="0" style="border-collapse: collapse; background-color: #ffffff; box-shadow: 0 0 10px rgba(0,0,0,0.1);">
                <thead>
                    <tr>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Локация</th>`;
                  departmentsMonth.forEach((department: any, idx: number) => {
                    if (idx <= 3) {
                      tableStr += `<th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">${department}</th>`;
                    }
                  });
                  if (departmentsMonth.length > 4) {
                    tableStr += `<th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">...</th>`;
                  }
                  tableStr += `<th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Общий итог</th>`;
                  tableStr += `</tr></thead><tbody>`;
                  locatioinsMonth.forEach((location: any) => {
                    tableStr += `<tr><td style="padding: 10px; border: 1px solid #ddd;">${location}</td>
                                        ${(departmentsMonth.length >= 1 &&
                        `<td style="padding: 10px; border: 1px solid #ddd;">${incWithQuestionsMonth.filter(
                          (inc: any) =>
                            inc.Location.get_lookupValue() ===
                            location &&
                            inc.Department.get_lookupValue() ===
                            departmentsMonth[0]
                        ).length
                        }</td>`) ||
                      ""
                      }
                                        ${(departmentsMonth.length >= 2 &&
                        `<td style="padding: 10px; border: 1px solid #ddd;">${incWithQuestionsMonth.filter(
                          (inc: any) =>
                            inc.Location.get_lookupValue() ===
                            location &&
                            inc.Department.get_lookupValue() ===
                            departmentsMonth[1]
                        ).length
                        }</td>`) ||
                      ""
                      }
                                        ${(departmentsMonth.length >= 3 &&
                        `<td style="padding: 10px; border: 1px solid #ddd;">${incWithQuestionsMonth.filter(
                          (inc: any) =>
                            inc.Location.get_lookupValue() ===
                            location &&
                            inc.Department.get_lookupValue() ===
                            departmentsMonth[2]
                        ).length
                        }</td>`) ||
                      ""
                      }
                                        ${(departmentsMonth.length === 4 &&
                        `<td style="padding: 10px; border: 1px solid #ddd;">${incWithQuestionsMonth.filter(
                          (inc: any) =>
                            inc.Location.get_lookupValue() ===
                            location &&
                            inc.Department.get_lookupValue() ===
                            departmentsMonth[3]
                        ).length
                        }</td>`) ||
                      ""
                      }
                                        ${(departmentsMonth.length > 4 &&
                        `<td style="padding: 10px; border: 1px solid #ddd;">${incWithQuestionsMonth.filter(
                          (inc: any) =>
                            inc.Location.get_lookupValue() ===
                            location &&
                            inc.Department.get_lookupValue() !==
                            departmentsMonth[3] &&
                            inc.Department.get_lookupValue() !==
                            departmentsMonth[2] &&
                            inc.Department.get_lookupValue() !==
                            departmentsMonth[1] &&
                            inc.Department.get_lookupValue() !==
                            departmentsMonth[0]
                        ).length
                        }</td>`) ||
                      ""
                      }
                                        ${`<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsMonth.filter(
                        (inc: any) =>
                          inc.Location.get_lookupValue() ===
                          location
                      ).length
                      }</td></tr>`}
                                        `;
                  });
                  tableStr += `<tr><td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">Общий итог</td>${(departmentsMonth.length >= 1 &&
                    `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsMonth.filter(
                      (inc: any) =>
                        inc.Department.get_lookupValue() ===
                        departmentsMonth[0]
                    ).length
                    }</td>`) ||
                    ""
                    }
                                    ${(departmentsMonth.length >= 2 &&
                      `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsMonth.filter(
                        (inc: any) =>
                          inc.Department.get_lookupValue() ===
                          departmentsMonth[1]
                      ).length
                      }</td>`) ||
                    ""
                    }
                                    ${(departmentsMonth.length >= 3 &&
                      `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsMonth.filter(
                        (inc: any) =>
                          inc.Department.get_lookupValue() ===
                          departmentsMonth[2]
                      ).length
                      }</td>`) ||
                    ""
                    }
                                    ${(departmentsMonth.length === 4 &&
                      `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsMonth.filter(
                        (inc: any) =>
                          inc.Department.get_lookupValue() ===
                          departmentsMonth[3]
                      ).length
                      }</td>`) ||
                    ""
                    }
                                    ${(departmentsMonth.length > 4 &&
                      `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsMonth.filter(
                        (inc: any) =>
                          inc.Department.get_lookupValue() !==
                          departmentsMonth[3] &&
                          inc.Department.get_lookupValue() !==
                          departmentsMonth[2] &&
                          inc.Department.get_lookupValue() !==
                          departmentsMonth[1] &&
                          inc.Department.get_lookupValue() !==
                          departmentsMonth[0]
                      ).length
                      }</td>`) ||
                    ""
                    }<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsMonth.length
                    }</td></tr>`;
                  tableStr += `</tbody></table>`;
                  tableStr += `<br/>`;

                  let incWithQuestionsYear: any = incWithQuestions.filter(
                    (item: any) =>
                      moment(item.DateIncidents).unix() >
                      localIncDateEmails.endDate.startOf("year").unix() &&
                      moment(item.DateIncidents).unix() <
                      localIncDateEmails.endDate.endOf("year").unix()
                  );
                  let departmentsYear = [
                    ..._.uniqWith(
                      incWithQuestionsYear.map((item: any) =>
                        item.Department.get_lookupValue()
                      ),
                      _.isEqual
                    ),
                  ];
                  let locatioinsYear = [
                    ..._.uniqWith(
                      incWithQuestionsYear.map((item: any) =>
                        item.Location.get_lookupValue()
                      ),
                      _.isEqual
                    ),
                  ];
                  tableStr += `<p style="font-weight: bold; padding: 12px;">YTD ${localIncDateEmails.endDate.format(
                    "YYYY"
                  )}:</p><table width="100%" cellspacing="0" cellpadding="8" border="0" style="border-collapse: collapse; background-color: #ffffff; box-shadow: 0 0 10px rgba(0,0,0,0.1);">
                <thead>
                    <tr>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Локация</th>`;
                  departmentsYear.forEach((department: any, idx: number) => {
                    if (idx <= 3) {
                      tableStr += `<th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">${department}</th>`;
                    }
                  });
                  if (departmentsYear.length > 4) {
                    tableStr += `<th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">...</th>`;
                  }
                  tableStr += `<th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Общий итог</th>`;
                  tableStr += `</tr></thead><tbody>`;
                  locatioinsYear.forEach((location: any) => {
                    tableStr += `<tr><td style="padding: 10px; border: 1px solid #ddd;">${location}</td>
                                        ${(departmentsYear.length >= 1 &&
                        `<td style="padding: 10px; border: 1px solid #ddd;">${incWithQuestionsYear.filter(
                          (inc: any) =>
                            inc.Location.get_lookupValue() ===
                            location &&
                            inc.Department.get_lookupValue() ===
                            departmentsYear[0]
                        ).length
                        }</td>`) ||
                      ""
                      }
                                        ${(departmentsYear.length >= 2 &&
                        `<td style="padding: 10px; border: 1px solid #ddd;">${incWithQuestionsYear.filter(
                          (inc: any) =>
                            inc.Location.get_lookupValue() ===
                            location &&
                            inc.Department.get_lookupValue() ===
                            departmentsYear[1]
                        ).length
                        }</td>`) ||
                      ""
                      }
                                        ${(departmentsYear.length >= 3 &&
                        `<td style="padding: 10px; border: 1px solid #ddd;">${incWithQuestionsYear.filter(
                          (inc: any) =>
                            inc.Location.get_lookupValue() ===
                            location &&
                            inc.Department.get_lookupValue() ===
                            departmentsYear[2]
                        ).length
                        }</td>`) ||
                      ""
                      }
                                        ${(departmentsYear.length === 4 &&
                        `<td style="padding: 10px; border: 1px solid #ddd;">${incWithQuestionsYear.filter(
                          (inc: any) =>
                            inc.Location.get_lookupValue() ===
                            location &&
                            inc.Department.get_lookupValue() ===
                            departmentsYear[3]
                        ).length
                        }</td>`) ||
                      ""
                      }
                                        ${(departmentsYear.length > 4 &&
                        `<td style="padding: 10px; border: 1px solid #ddd;">${incWithQuestionsYear.filter(
                          (inc: any) =>
                            inc.Location.get_lookupValue() ===
                            location &&
                            inc.Department.get_lookupValue() !==
                            departmentsYear[3] &&
                            inc.Department.get_lookupValue() !==
                            departmentsYear[2] &&
                            inc.Department.get_lookupValue() !==
                            departmentsYear[1] &&
                            inc.Department.get_lookupValue() !==
                            departmentsYear[0]
                        ).length
                        }</td>`) ||
                      ""
                      }
                                        ${`<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsYear.filter(
                        (inc: any) =>
                          inc.Location.get_lookupValue() ===
                          location
                      ).length
                      }</td></tr>`}
                                        `;
                  });
                  tableStr += `<tr><td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">Общий итог</td>${(departmentsYear.length >= 1 &&
                    `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsYear.filter(
                      (inc: any) =>
                        inc.Department.get_lookupValue() ===
                        departmentsYear[0]
                    ).length
                    }</td>`) ||
                    ""
                    }
                                    ${(departmentsYear.length >= 2 &&
                      `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsYear.filter(
                        (inc: any) =>
                          inc.Department.get_lookupValue() ===
                          departmentsYear[1]
                      ).length
                      }</td>`) ||
                    ""
                    }
                                    ${(departmentsYear.length >= 3 &&
                      `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsYear.filter(
                        (inc: any) =>
                          inc.Department.get_lookupValue() ===
                          departmentsYear[2]
                      ).length
                      }</td>`) ||
                    ""
                    }
                                    ${(departmentsYear.length === 4 &&
                      `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsYear.filter(
                        (inc: any) =>
                          inc.Department.get_lookupValue() ===
                          departmentsYear[3]
                      ).length
                      }</td>`) ||
                    ""
                    }
                                    ${(departmentsYear.length > 4 &&
                      `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsYear.filter(
                        (inc: any) =>
                          inc.Department.get_lookupValue() !==
                          departmentsYear[3] &&
                          inc.Department.get_lookupValue() !==
                          departmentsYear[2] &&
                          inc.Department.get_lookupValue() !==
                          departmentsYear[1] &&
                          inc.Department.get_lookupValue() !==
                          departmentsYear[0]
                      ).length
                      }</td>`) ||
                    ""
                    }<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsYear.length
                    }</td></tr>`;
                  tableStr += `</tbody></table>`;
                  tableStr += `<br/>`;

                  tableStr += `<p style="font-weight: bold; padding: 12px;">В настоящий момент в системе Мои Задачи <span style="text-decoration: underline">отсутствуют расследования (весь период)</span></p><table width="100%" cellspacing="0" cellpadding="8" border="0" style="border-collapse: collapse; background-color: #ffffff; box-shadow: 0 0 10px rgba(0,0,0,0.1);">
                <thead>
                    <tr>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">ID</th>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Дата регистрации</th>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Локация</th>
                    </tr>
                </thead><tbody>`;
                  incWithQuestions
                    .filter(
                      (inc: any) =>
                        inc.Status.get_lookupId() !== incStatus.finish &&
                        inc.Status.get_lookupId() !== incStatus.cancel
                    )
                    .forEach((inc: any) => {
                      tableStr += `<tr>
                    <td style="background-color: #00629B; color: white; font-weight: bold; padding: 10px; border: 1px solid #ddd;">
                        <a href="${siteUrl}${urlDefault}/dashboard/3/incidents-and-nonconformities?incidentCard=${inc.ID
                        }&removeMail=${timestamp}" style="color: white; text-decoration: underline;">${inc.ID
                        }</a>
                    </td>
                    <td style="padding: 10px; border: 1px solid #ddd;">${moment(
                          inc.DateIncidents
                        ).format("DD.MM.YYYY")}</td>
                    <td style="padding: 10px; border: 1px solid #ddd;">${inc.Location.get_lookupValue()}</td>
                </tr>`;
                    });
                  tableStr += `</tbody></table>`;
                  tableStr += `<br/>`;

                  let locatioinsActions = [
                    ..._.uniqWith(
                      incWithQuestions.map((item: any) =>
                        item.Location.get_lookupValue()
                      ),
                      _.isEqual
                    ),
                  ];
                  let locationsActionsObj: any = {};
                  locatioinsActions.forEach((loc: any) => {
                    locationsActionsObj[loc] = {
                      process: incWithQuestions
                        .map(
                          (inc: any) =>
                            inc.Location.get_lookupValue() === loc &&
                            inc.processActionsCount
                        )
                        .reduce(
                          (accumulator: number, currentValue: number) =>
                            accumulator + currentValue,
                          0
                        ),
                      overdue: incWithQuestions
                        .map(
                          (inc: any) =>
                            inc.Location.get_lookupValue() === loc &&
                            inc.overdueActionsCount
                        )
                        .reduce(
                          (accumulator: number, currentValue: number) =>
                            accumulator + currentValue,
                          0
                        ),
                    };
                  });
                  tableStr += `<p style="font-weight: bold; padding: 12px;">Незакрытые действия (весь период)</p><table width="100%" cellspacing="0" cellpadding="8" border="0" style="border-collapse: collapse; background-color: #ffffff; box-shadow: 0 0 10px rgba(0,0,0,0.1);">
                <thead>
                    <tr>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Локация</th><th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">В процессе</th><th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Просрочено</th>`;
                  tableStr += `</tr></thead><tbody>`;
                  locatioinsActions.forEach((location: any) => {
                    tableStr += `<tr><td style="padding: 10px; border: 1px solid #ddd;">${location}</td><td style="padding: 10px; border: 1px solid #ddd;">${locationsActionsObj[location]["process"]}</td><td style="padding: 10px; border: 1px solid #ddd;">${locationsActionsObj[location]["overdue"]}</td></tr>`;
                  });
                  tableStr += `<tr><td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">Общий итог</td><td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestions
                    .map((inc: any) => inc.processActionsCount)
                    .reduce(
                      (accumulator: number, currentValue: number) =>
                        accumulator + currentValue,
                      0
                    )}</td><td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestions
                      .map((inc: any) => inc.overdueActionsCount)
                      .reduce(
                        (accumulator: number, currentValue: number) =>
                          accumulator + currentValue,
                        0
                      )}</td></tr>`;
                  tableStr += `</tbody></table>`;
                  tableStr += `<br/>`;
                  const elem: any = document.querySelector("#tempScreen");
                  setTempScreenData(locationsActionsObj);
                  setTempScrenLabels([
                    {
                      label: "В процессе",
                      color: "#F2A900",
                      type: "process",
                    },
                    {
                      label: "Просрочено",
                      color: "#BA0C2F",
                      type: "overdue",
                    },
                  ]);
                  elem.style.display = "flex";
                  setTimeout(() => {
                    html2canvas(elem, {
                      useCORS: true,
                      allowTaint: true,
                    }).then(function (canvas) {
                      elem.style.display = "none";
                      const urlScreen = canvas.toDataURL();
                      tableStr += `<img src="${urlScreen}" alt=""><br/>`;
                      getItemsRequest({
                        listName: myTasksIncidentsRecipientsListListName,
                        filters: {
                          Title: `${formDataSendEmails["TypeIncident"]}*`,
                        },
                        sortOrder: { name: "ID", desc: true },
                      }).then((results) => {
                        const emails = results.items[0]["Emails"] || "";
                        const copies = results.items[0]["Copies"] || "";
                        if (emailsSender && formDataSendEmails.Msg === "Нет") {
                          const emailBody = {
                            Body: tableStr,
                            DateToBeSentAt: moment()
                              .subtract(12, "hours")
                              .toDate(),
                            Title: "Мои Задачи | Отчет по инцидентам",
                            Subject: "Мои Задачи | Отчет по инцидентам",
                            Recepients: emails,
                            CC: copies,
                            CheckDoc: String(timestamp),
                          };
                          Promise.all([sendEmail(emailBody)]).then(() => {
                            setLoadingSetEmail(false);
                            setOpenSendReportModal(!openSendReportModal);
                            setFormDataSetEmails(null);
                          });
                        } else {
                          const downloadOutlookFile = async () => {
                            try {
                              await downloadOutlookEmailWithAttachments({
                                from: {
                                  name: currentUser.displayName,
                                  email: currentUser.email,
                                },
                                to:
                                  (emails &&
                                    emails.split(",").map((email: string) => {
                                      return {
                                        name: email.trim(),
                                        email: email.trim(),
                                      };
                                    })) ||
                                  [],
                                cc:
                                  (copies &&
                                    copies.split(",").map((email: string) => {
                                      return {
                                        name: email.trim(),
                                        email: email.trim(),
                                      };
                                    })) ||
                                  [],
                                subject: "Отчет по инцидентам",
                                htmlBody: tableStr,
                                textBody: "",
                                attachments: [],
                                fileName: "reports_inc.eml",
                              });
                            } catch (error) {
                              console.error("Ошибка:", error);
                            }
                          };
                          downloadOutlookFile().then(() => {
                            setLoadingSetEmail(false);
                            setOpenSendReportModal(!openSendReportModal);
                            setFormDataSetEmails(null);
                          });
                        }
                      });
                    });
                  }, 3000);
                }
                if (idCurrentTypeInc === incTypes.q) {
                  let incWithQuestionsPeriod: any = incWithQuestions.filter(
                    (item: any) =>
                      moment(item.DateIncidents).unix() >
                      localIncDateEmails.start &&
                      moment(item.DateIncidents).unix() < localIncDateEmails.end
                  );
                  let categoryPeriodProcces = incWithQuestionsPeriod.map(
                    (item: any) =>
                      item.QAProcessIncidentCategory &&
                      item.QAProcessIncidentCategory.name
                  );
                  let categoryPeriodQA = incWithQuestionsPeriod.map(
                    (item: any) =>
                      item.QAIncidentCategory && item.QAIncidentCategory.name
                  );
                  let locatioinsPeriod = [
                    ..._.uniqWith(
                      incWithQuestionsPeriod.map((item: any) =>
                        item.Location.get_lookupValue()
                      ),
                      _.isEqual
                    ),
                  ];
                  let categoryPeriod = [
                    ..._.uniqWith(
                      [...categoryPeriodProcces, ...categoryPeriodQA],
                      _.isEqual
                    ),
                  ].filter((element) => element !== undefined);

                  tableStr += `<p style="font-weight: bold; padding: 12px; text-decoration: underline;">Статистика по заводам с ${formDataSendEmails["DateIncidents"].startDate} по ${formDataSendEmails["DateIncidents"].endDate} (*Категория инцидента):</p><table width="100%" cellspacing="0" cellpadding="8" border="0" style="border-collapse: collapse; background-color: #ffffff; box-shadow: 0 0 10px rgba(0,0,0,0.1);">
                <thead>
                    <tr>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Локация</th>`;
                  categoryPeriod.forEach((category: any) => {
                    tableStr += `<th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">${category}</th>`;
                  });
                  tableStr += `<th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Общий итог</th>`;
                  tableStr += `</tr></thead><tbody>`;
                  locatioinsPeriod.forEach((location: any) => {
                    tableStr += `<tr><td style="padding: 10px; border: 1px solid #ddd;">${location}</td>`;
                    categoryPeriod.forEach((category) => {
                      tableStr += `<td style="padding: 10px; border: 1px solid #ddd;">${incWithQuestionsPeriod.filter(
                        (inc: any) =>
                          inc.Location.get_lookupValue() === location &&
                          ((inc.QAProcessIncidentCategory &&
                            inc.QAProcessIncidentCategory["name"] ===
                            category) ||
                            (inc.QAIncidentCategory &&
                              inc.QAIncidentCategory["name"] === category))
                      ).length
                        }</td>`;
                    });
                    tableStr += `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsPeriod.filter(
                      (inc: any) =>
                        inc.Location.get_lookupValue() === location
                    ).length
                      }</td></tr>`;
                  });
                  tableStr += `<tr><td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">Общий итог</td>`;
                  categoryPeriod.forEach((category) => {
                    tableStr += `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsPeriod.filter(
                      (inc: any) =>
                        (inc.QAProcessIncidentCategory &&
                          inc.QAProcessIncidentCategory.name === category) ||
                        (inc.QAIncidentCategory &&
                          inc.QAIncidentCategory.name === category)
                    ).length
                      }</td>`;
                  });
                  tableStr += `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsPeriod.length}</td></tr>`;
                  tableStr += `</tbody></table>`;
                  tableStr += `<br/>`;

                  let locationsPeriodObj: any = {};
                  locatioinsPeriod.forEach((loc: any) => {
                    categoryPeriod.forEach((category: any) => {
                      locationsPeriodObj[loc] = {
                        ...locationsPeriodObj[loc],
                        [category]: incWithQuestionsPeriod.filter(
                          (inc: any) =>
                            inc.Location.get_lookupValue() === loc &&
                            ((inc.QAProcessIncidentCategory &&
                              inc.QAProcessIncidentCategory["name"] ===
                              category) ||
                              (inc.QAIncidentCategory &&
                                inc.QAIncidentCategory["name"] === category))
                        ).length,
                      };
                    });
                  });
                  setTempScreenData(locationsPeriodObj);
                  let tempLabels: any = [];
                  categoryPeriod.forEach((category) => {
                    tempLabels = [
                      ...tempLabels,
                      {
                        label: category,
                        color: getRandomColor(),
                        type: category,
                      },
                    ];
                  });
                  setTempScrenLabels([...tempLabels]);
                  const elem: any = document.querySelector("#tempScreen");
                  elem.style.display = "flex";
                  setTimeout(() => {
                    html2canvas(elem, {
                      useCORS: true,
                      allowTaint: true,
                    }).then(function (canvas) {
                      elem.style.display = "none";
                      const urlScreen = canvas.toDataURL();
                      tableStr += `<img src="${urlScreen}" alt=""><br/>`;
                      setTempScreenData({});
                      setTempScrenLabels([]);

                      let incWithQuestionsMonth: any = incWithQuestions.filter(
                        (item: any) =>
                          moment(item.DateIncidents).unix() >
                          localIncDateEmails.endDate.startOf("M").unix() &&
                          moment(item.DateIncidents).unix() <
                          localIncDateEmails.endDate.endOf("M").unix()
                      );
                      let categoryMonthProcces = incWithQuestionsMonth.map(
                        (item: any) =>
                          item.QAProcessIncidentCategory &&
                          item.QAProcessIncidentCategory.name
                      );
                      let categoryMonthQA = incWithQuestionsMonth.map(
                        (item: any) =>
                          item.QAIncidentCategory &&
                          item.QAIncidentCategory.name
                      );
                      let locatioinsMonth = [
                        ..._.uniqWith(
                          incWithQuestionsMonth.map((item: any) =>
                            item.Location.get_lookupValue()
                          ),
                          _.isEqual
                        ),
                      ];
                      let categoryMonth = [
                        ..._.uniqWith(
                          [...categoryMonthProcces, ...categoryMonthQA],
                          _.isEqual
                        ),
                      ].filter((element) => element !== undefined);

                      tableStr += `<p style="font-weight: bold; padding: 12px; text-decoration: underline;">MTD ${localIncDateEmails.endDate.format(
                        "MMMM YYYY"
                      )}:</p><table width="100%" cellspacing="0" cellpadding="8" border="0" style="border-collapse: collapse; background-color: #ffffff; box-shadow: 0 0 10px rgba(0,0,0,0.1);">
                <thead>
                    <tr>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Локация</th>`;
                      categoryMonth.forEach((category: any) => {
                        tableStr += `<th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">${category}</th>`;
                      });
                      tableStr += `<th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Общий итог</th>`;
                      tableStr += `</tr></thead><tbody>`;
                      locatioinsMonth.forEach((location: any) => {
                        tableStr += `<tr><td style="padding: 10px; border: 1px solid #ddd;">${location}</td>`;
                        categoryMonth.forEach((category) => {
                          tableStr += `<td style="padding: 10px; border: 1px solid #ddd;">${incWithQuestionsMonth.filter(
                            (inc: any) =>
                              inc.Location.get_lookupValue() === location &&
                              ((inc.QAProcessIncidentCategory &&
                                inc.QAProcessIncidentCategory["name"] ===
                                category) ||
                                (inc.QAIncidentCategory &&
                                  inc.QAIncidentCategory["name"] ===
                                  category))
                          ).length
                            }</td>`;
                        });
                        tableStr += `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsMonth.filter(
                          (inc: any) =>
                            inc.Location.get_lookupValue() === location
                        ).length
                          }</td></tr>`;
                      });
                      tableStr += `<tr><td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">Общий итог</td>`;
                      categoryMonth.forEach((category) => {
                        tableStr += `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsMonth.filter(
                          (inc: any) =>
                            (inc.QAProcessIncidentCategory &&
                              inc.QAProcessIncidentCategory.name ===
                              category) ||
                            (inc.QAIncidentCategory &&
                              inc.QAIncidentCategory.name === category)
                        ).length
                          }</td>`;
                      });
                      tableStr += `<td style="padding: 10px; border: 1px solid #ddd; background-color: #E3EEF4; font-weight: bold">${incWithQuestionsMonth.length}</td></tr>`;
                      tableStr += `</tbody></table>`;
                      tableStr += `<br/>`;

                      let locationsMonthObj: any = {};
                      locatioinsMonth.forEach((loc: any) => {
                        categoryMonth.forEach((category: any) => {
                          locationsMonthObj[loc] = {
                            ...locationsMonthObj[loc],
                            [category]: incWithQuestionsMonth.filter(
                              (inc: any) =>
                                inc.Location.get_lookupValue() === loc &&
                                ((inc.QAProcessIncidentCategory &&
                                  inc.QAProcessIncidentCategory["name"] ===
                                  category) ||
                                  (inc.QAIncidentCategory &&
                                    inc.QAIncidentCategory["name"] ===
                                    category))
                            ).length,
                          };
                        });
                      });
                      setTempScreenData(locationsMonthObj);
                      let tempLabels: any = [];
                      categoryMonth.forEach((category) => {
                        tempLabels = [
                          ...tempLabels,
                          {
                            label: category,
                            color: getRandomColor(),
                            type: category,
                          },
                        ];
                      });
                      setTempScrenLabels([...tempLabels]);
                      elem.style.display = "flex";
                      setTimeout(() => {
                        html2canvas(elem, {
                          useCORS: true,
                          allowTaint: true,
                        }).then(function (canvas) {
                          elem.style.display = "none";
                          const urlScreen = canvas.toDataURL();
                          tableStr += `<img src="${urlScreen}" alt=""><br/>`;
                          tableStr += `<p style="font-weight: bold; padding: 12px;">В настоящий момент в системе Мои Задачи <span style="text-decoration: underline">отсутствуют расследования (весь период)</span></p><table width="100%" cellspacing="0" cellpadding="8" border="0" style="border-collapse: collapse; background-color: #ffffff; box-shadow: 0 0 10px rgba(0,0,0,0.1);">
                <thead>
                    <tr>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">ID</th>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Дата регистрации</th>
                        <th style="background-color: #00629B; color: white; font-weight: bold; text-align: left; padding: 12px; border: 1px solid #ddd;">Локация</th>
                    </tr>
                </thead><tbody>`;
                          incWithQuestions
                            .filter(
                              (inc: any) =>
                                inc.Status.get_lookupId() !==
                                incStatus.finish &&
                                inc.Status.get_lookupId() !== incStatus.cancel
                            )
                            .forEach((inc: any) => {
                              tableStr += `<tr>
                    <td style="background-color: #00629B; color: white; font-weight: bold; padding: 10px; border: 1px solid #ddd;">
                        <a href="${siteUrl}${urlDefault}/dashboard/3/incidents-and-nonconformities?incidentCard=${inc.ID
                                }&removeMail=${timestamp}" style="color: white; text-decoration: underline;">${inc.ID
                                }</a>
                    </td>
                    <td style="padding: 10px; border: 1px solid #ddd;">${moment(
                                  inc.DateIncidents
                                ).format("DD.MM.YYYY")}</td>
                    <td style="padding: 10px; border: 1px solid #ddd;">${inc.Location.get_lookupValue()}</td>
                </tr>`;
                            });
                          tableStr += `</tbody></table>`;
                          tableStr += `<br/>`;
                          setTempScreenData({});
                          setTempScrenLabels([]);
                          getItemsRequest({
                            listName: myTasksIncidentsRecipientsListListName,
                            filters: {
                              Title: `${formDataSendEmails["TypeIncident"]}*`,
                            },
                            sortOrder: { name: "ID", desc: true },
                          }).then((results) => {
                            const emails = results.items[0]["Emails"] || "";
                            const copies = results.items[0]["Copies"] || "";
                            if (
                              emailsSender &&
                              formDataSendEmails.Msg === "Нет"
                            ) {
                              const emailBody = {
                                Body: tableStr,
                                DateToBeSentAt: moment()
                                  .subtract(12, "hours")
                                  .toDate(),
                                Title: "Мои Задачи | Отчет по инцидентам",
                                Subject: "Мои Задачи | Отчет по инцидентам",
                                Recepients: emails,
                                CC: copies,
                                CheckDoc: String(timestamp),
                              };
                              Promise.all([sendEmail(emailBody)]).then(() => {
                                setLoadingSetEmail(false);
                                setOpenSendReportModal(!openSendReportModal);
                                setFormDataSetEmails(null);
                              });
                            } else {
                              const downloadOutlookFile = async () => {
                                try {
                                  await downloadOutlookEmailWithAttachments({
                                    from: {
                                      name: currentUser.displayName,
                                      email: currentUser.email,
                                    },
                                    to:
                                      (emails &&
                                        emails
                                          .split(",")
                                          .map((email: string) => {
                                            return {
                                              name: email.trim(),
                                              email: email.trim(),
                                            };
                                          })) ||
                                      [],
                                    cc:
                                      (copies &&
                                        copies
                                          .split(",")
                                          .map((email: string) => {
                                            return {
                                              name: email.trim(),
                                              email: email.trim(),
                                            };
                                          })) ||
                                      [],
                                    subject: "Отчет по инцидентам",
                                    htmlBody: tableStr,
                                    textBody: "",
                                    attachments: [],
                                    fileName: "reports_inc.eml",
                                  });
                                } catch (error) {
                                  console.error("Ошибка:", error);
                                }
                              };
                              downloadOutlookFile().then(() => {
                                setLoadingSetEmail(false);
                                setOpenSendReportModal(!openSendReportModal);
                                setFormDataSetEmails(null);
                              });
                            }
                          });
                        });
                      }, 3000);
                    });
                  }, 3000);
                }
                if (
                  idCurrentTypeInc !== incTypes.m &&
                  idCurrentTypeInc !== incTypes.q
                ) {
                  getItemsRequest({
                    listName: myTasksIncidentsRecipientsListListName,
                    filters: {
                      Title: `${formDataSendEmails["TypeIncident"]}*`,
                    },
                    sortOrder: { name: "ID", desc: true },
                  }).then(async (results) => {
                    const emails = results.items[0]["Emails"] || "";
                    const copies = results.items[0]["Copies"] || "";
                    if (emailsSender && formDataSendEmails.Msg === "Нет") {
                      const emailBody = {
                        Body: tableStr,
                        DateToBeSentAt: moment().subtract(12, "hours").toDate(),
                        Title: "Мои Задачи | Отчет по инцидентам",
                        Subject: "Мои Задачи | Отчет по инцидентам",
                        Recepients: emails,
                        CC: copies,
                        CheckDoc: String(timestamp),
                      };
                      Promise.all([sendEmail(emailBody)]).then(() => {
                        setLoadingSetEmail(false);
                        setOpenSendReportModal(!openSendReportModal);
                        setFormDataSetEmails(null);
                      });
                    } else {
                      const downloadOutlookFile = async () => {
                        try {
                          await downloadOutlookEmailWithAttachments({
                            from: {
                              name: currentUser.displayName,
                              email: currentUser.email,
                            },
                            to:
                              (emails &&
                                emails.split(",").map((email: string) => {
                                  return {
                                    name: email.trim(),
                                    email: email.trim(),
                                  };
                                })) ||
                              [],
                            cc:
                              (copies &&
                                copies.split(",").map((email: string) => {
                                  return {
                                    name: email.trim(),
                                    email: email.trim(),
                                  };
                                })) ||
                              [],
                            subject: "Отчет по инцидентам",
                            htmlBody: tableStr,
                            textBody: "",
                            attachments: [],
                            fileName: "reports_inc.eml",
                          });
                        } catch (error) {
                          console.error("Ошибка:", error);
                        }
                      };
                      downloadOutlookFile().then(() => {
                        setLoadingSetEmail(false);
                        setOpenSendReportModal(!openSendReportModal);
                        setFormDataSetEmails(null);
                      });
                    }
                  });
                }
              } else {
                setLoadingSetEmail(false);
                setOpenSendReportModal(!openSendReportModal);
                setFormDataSetEmails(null);
              }
            });
          });
        });
      });
    }
  }, [formDataSendEmails]);

  return (
    <FlexRow className="scrollbar scrollbar-w-2 scrollbar-h-2 scrollbar-thumb-rounded-md scrollbar-thumb-[#D1D5DB] h-screen overflow-y-auto">
      <FlexCol className="bg-white sticky-custom border-r w-80 text-[14px] text-[#8899A8] relative scrollbar scrollbar-w-2  scrollbar-h-2 scrollbar-thumb-rounded-md scrollbar-thumb-[#D1D5DB] max-h-screen">
        <FlexCol className="max-w-[320px] overflow-y-auto scrollbar scrollbar-w-2 scrollbar-h-2 scrollbar-thumb-rounded-md scrollbar-thumb-[#D1D5DB]">
          <IncidentsFilters
            filters={filters}
            setGegIncidents={setGegIncidents}
            setFilters={setFilters}
            setPeriod={setPeriod}
          />
        </FlexCol>
      </FlexCol>
      <FlexCol className="grow w-[calc(100%-320px)]">
        <FlexCol className="w-full">
          <FlexRow className="px-7.5 h-[76px] border-b justify-between items-center shrink-0">
            <FlexCol>
              <Breadcrumbs
                items={[
                  {
                    name: "Отчеты",
                    icon: <ReportIcon />,
                  },
                  {
                    name: "Отчет по инцидентам",
                    icon: <WarningSmallIcon />,
                  },
                ]}
              />
            </FlexCol>
            {/* <FlexCol>
              <TGButton onClick={() => setOpenSendReportModal(true)}>
                Отправить по почте
              </TGButton>
            </FlexCol> */}
          </FlexRow>
          <FlexRow className="m-7.5 mb-2.5 shrink-0 flex-wrap">
            <FlexCol className="w-full space-y-2.5 gap-[20px]">
              {(customLoading && (
                <FlexCol className="items-center justify-center w-full">
                  <span className="block mb-5 text-base text-darkblue">
                    Получаем данные...
                  </span>
                  <Loading />
                </FlexCol>
              )) || (
                  <>
                    <BarChart
                      data={{ ...chartYearData, labels: monthLabels }}
                      options={chartYOptions}
                      title={
                        <FlexRow className="absolute translate-x-[-50%] translate-y-[-50%] top-[1%] left-[50%]">
                          <FlexCol
                            className="hover:text-darkblue hover:cursor-pointer"
                            onClick={() =>
                              setYear((prev: any) =>
                                moment(prev).subtract(1, "year")
                              )
                            }
                          >
                            <PaginationLeftSmallIcon />
                          </FlexCol>
                          <FlexCol className="text-black select-none mt-[2px]">
                            {moment(year).format("YYYY")}
                          </FlexCol>
                          <FlexCol
                            className="hover:text-darkblue hover:cursor-pointer"
                            onClick={() =>
                              setYear((prev: any) => moment(prev).add(1, "year"))
                            }
                          >
                            <PaginationRightSmallIcon />
                          </FlexCol>
                        </FlexRow>
                      }
                    />
                    <BarChart
                      data={{ ...chartFactoryData, labels: factoriesLabels }}
                      options={chartPeriodOptions}
                      title={
                        <FlexRow className="absolute translate-x-[-50%] translate-y-[-50%] top-[1%] left-[50%]">
                          <FlexCol className="text-black">
                            Статусы инцидентов по заводам
                          </FlexCol>
                        </FlexRow>
                      }
                    />
                    {filters.TypeIncident === incTypes.q && (
                      <BarChart
                        data={{ ...chartQualityData, labels: qualityLabels }}
                        options={chartQualityOptions}
                        title={
                          <FlexRow className="absolute translate-x-[-50%] translate-y-[-50%] top-[1%] left-[50%]">
                            <FlexCol className="text-black">
                              Категории инцидентов по качеству и в процессе
                            </FlexCol>
                          </FlexRow>
                        }
                      />
                    )}
                    {filters.TypeIncident === incTypes.m && (
                      <>
                        <BarChart
                          data={{ ...chartMData, labels: mLabels }}
                          options={chartMOptions}
                          title={
                            <FlexRow className="absolute translate-x-[-50%] translate-y-[-50%] top-[1%] left-[50%]">
                              <FlexCol className="text-black">
                                Направления
                              </FlexCol>
                            </FlexRow>
                          }
                        />
                        <FlexCol
                          id="testScreenshotActions"
                          className="relative w-full pt-5 bg-white border rounded-lg"
                        >
                          <FlexRow className="absolute translate-x-[-50%] translate-y-[-50%] top-[3.5%] left-[50%]">
                            <FlexCol className="text-black">
                              Незакрытые действия
                            </FlexCol>
                          </FlexRow>
                          <ChartLicense
                            data={chartMActionsData}
                            labels={mLabelsActions}
                          />
                        </FlexCol>
                      </>
                    )}
                  </>
                )}
            </FlexCol>
          </FlexRow>
        </FlexCol>
        <Modal
          zIndex={70}
          open={openSendReportModal}
          toggleDialog={(state) => setOpenSendReportModal(state)}
          modalClassName="min-h-0 flex"
          hideXMarkIcon={(!loadingSendEmail && true) || false}
        >
          {(!loadingSendEmail && (
            <>
              <header className="px-10">
                <h2>Отчет по инцидентам</h2>
              </header>
              <FlexCol className="flex-1 px-10 py-5 space-y-4">
                <Form
                  type="report_my_tasks_inc_send_emails"
                  setFormData={setFormDataSetEmails}
                  fieldsForm={[...fieldsSendEmails]}
                  defaultValues={null}
                  openCancelAddCard={openSendReportModal}
                  setOpenCancelAddCard={setOpenSendReportModal}
                />
              </FlexCol>
            </>
          )) || (
              <>
                <FlexCol className="items-center justify-center w-full">
                  <span className="block mb-5 text-base text-darkblue">
                    Отправляем данные...
                  </span>
                  <Loading />
                </FlexCol>
                <br />
                <FlexCol
                  className="w-full"
                  id="tempScreen"
                  style={{ display: "none" }}
                >
                  <ChartLicense
                    data={tempScreenData}
                    labels={tempScrenLabels}
                    reportInc={true}
                  />
                </FlexCol>
              </>
            )}
        </Modal>
      </FlexCol>
    </FlexRow>
  );
}
